{
	"dialog.ok": "OK",
	"dialog.cancel": "Cancelar",
	"dialog.confirm": "Confirmar",
	"dialog.close": "Fechar",
	"dialog.import": "Importar",
	"dialog.save": "Salvar",
	"dialog.discard": "Descartar",
	"dialog.dontshowagain": "Não mostrar de novo",
	"data.cube": "Cubo",
	"data.group": "Grupo",
	"data.texture": "Textura",
	"data.plugin": "Plugin",
	"data.preview": "Pré-visualização",
	"data.toolbar": "Barra de ferramentas",
	"data.image": "Imagem",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Espaço",
	"keys.leftclick": "Clique esquerdo",
	"keys.middleclick": "Clique do meio",
	"keys.rightclick": "Clique direito",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Esc",
	"keys.function": "F%0",
	"keys.numpad": "Numérico %0",
	"keys.caps": "Capslock",
	"keys.menu": "Contextmenu",
	"keys.left": "Seta para esquerda",
	"keys.up": "Seta para cima",
	"keys.right": "Seta para direita",
	"keys.down": "Seta para baixo",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Mais",
	"keys.comma": "Vírgula",
	"keys.point": "Ponto",
	"keys.minus": "Menos",
	"keys.cross": "Cruz",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "Limites de rotação",
	"message.rotation_limit.message": "As rotações no Minecraft são limitadas a um eixo e incrementos de 22.5 graus. Rotacionar em um eixo diferente irá limpar todas as rotações nos outros eixos. Converta o modelo para \"Modelo Padrão\" se estiver modelando para outras finalidades e precisa de rotações livres.",
	"message.file_not_found.title": "Arquivo não encontrado",
	"message.file_not_found.message": "O Blockbench não pôde encontrar o arquivo solicitado. Verifique se ele está salvo localmente e não em nuvem.",
	"message.screenshot.title": "Captura de tela",
	"message.screenshot.clipboard": "Área de transferência",
	"message.screenshot.right_click": "Captura de tela — Botão direito do mouse para copiar",
	"message.invalid_file.title": "Arquivo inválido",
	"message.invalid_file.message": "Não foi possível abrir o arquivo JSON: %0",
	"message.invalid_model.title": "Arquivo de modelo inválido",
	"message.invalid_model.message": "Esse arquivo tem dados de modelo inválidos.",
	"message.child_model_only.title": "Modelo derivado vazio\n",
	"message.child_model_only.message": "Esse arquivo é derivado de %0 e não tem nenhum modelo.",
	"message.unsaved_textures.title": "Texturas não salvas",
	"message.unsaved_textures.message": "Seu modelo tem texturas que ainda não foram salvas. Certifique-se de salvá-las e colá-las na pasta correta do seu pacote de recursos.",
	"message.model_clipping.title": "Modelo muito grande",
	"message.model_clipping.message": "Isso não funcionará porque seu modelo tem %0 cubos maiores que o limite de 3x3x3 permitido pelo Minecraft.",
	"message.loose_texture.title": "Importar textura",
	"message.loose_texture.message": "A textura importada não faz parte de um pacote de recursos. O Minecraft só pode carregar texturas da pasta de texturas de um pacote de recursos que esteja carregado.",
	"message.loose_texture.change": "Mudar caminho",
	"message.update_res.title": "Resolução da textura",
	"message.update_res.message": "Deseja atualizar a resolução do projeto para a resolução dessa textura? Clique em 'Cancelar' se a sua textura tem uma resolução maior que o normal.",
	"message.update_res.update": "Atualizar",
	"message.bedrock_overwrite_error.message": "O Blockbench não pode combinar esse modelo com o arquivo antigo",
	"message.bedrock_overwrite_error.backup_overwrite": "Criar cópia e substituir",
	"message.bedrock_overwrite_error.overwrite": "Substituir",
	"message.close_warning.message": "Deseja salvar o seu modelo?",
	"message.close_warning.web": "O seu trabalho atual será perdido. Deseja mesmo sair?",
	"message.default_textures.title": "Textura padrão",
	"message.default_textures.message": "Selecione a pasta \"textures\" do pacote de recursos padrão",
	"message.default_textures.detail": "Extraia o pacote de texturas padrão do jar do Minecraft, ou baixe-o da internet. Em seguida, localize e abra a pasta \"textures\". O Blockbench se lembrará desse local e tentará obter texturas a partir dele se não puder encontrá-las no pacote de recursos atual.",
	"message.default_textures.select": "Selecione a pasta padrão \"textures\"",
	"message.image_editor.title": "Selecione um editor de imagens",
	"message.image_editor.file": "Selecionar um arquivo...",
	"message.image_editor.exe": "Selecione o executável do editor de imagens",
	"message.display_skin.title": "Mostrar skin",
	"message.display_skin.message": "Selecione uma skin em seu computador ou digite o nome de um jogador",
	"message.display_skin.upload": "Carregar uma skin",
	"message.display_skin.reset": "Redefinir",
	"message.invalid_plugin": "Extensão inválida. Veja o console",
	"message.load_plugin_app": "Deseja permitir que essa extensão faça alterações no seu computador? Apenas carregue extensões de fontes confiáveis.",
	"message.load_plugin_web": "Deseja carregar este plugin? Apenas carregue plugins de fontes confiáveis.",
	"message.preset_no_info": "A predefinição não tem informações para esse espaço",
	"message.restart_to_update": "Reinicie o Blockbench para aplicar as mudanças",
	"message.save_file": "Salvo como %0",
	"dialog.project.title": "Projeto",
	"dialog.project.name": "Nome do arquivo",
	"dialog.project.parent": "Modelo derivado",
	"dialog.project.geoname": "Identificador do modelo",
	"dialog.project.ao": "Oclusão de ambiente",
	"dialog.texture.title": "Textura",
	"dialog.texture.variable": "Variável",
	"dialog.texture.namespace": "Espaço de nomes",
	"dialog.texture.folder": "Pasta",
	"dialog.extrude.title": "Extrudir imagem",
	"dialog.extrude.mode": "Modo varredura",
	"dialog.extrude.mode.areas": "Áreas",
	"dialog.extrude.mode.lines": "Linhas",
	"dialog.extrude.mode.columns": "Colunas",
	"dialog.extrude.mode.pixels": "Píxeis",
	"dialog.extrude.opacity": "Opacidade mínima",
	"dialog.extrude.scan": "Escanear e importar",
	"dialog.display_preset.title": "Criar predefinição",
	"dialog.display_preset.message": "Selecione os espaços que deseja salvar",
	"dialog.display_preset.create": "Criar",
	"dialog.select.title": "Selecionar",
	"dialog.select.group": "No grupo selecionado",
	"dialog.select.name": "O nome contém",
	"dialog.select.random": "Chance aleatória (%)",
	"dialog.select.select": "Selecionar",
	"dialog.scale.title": "Escala do modelo",
	"dialog.scale.axis": "Eixo",
	"dialog.scale.clipping": "Modelo de recorte: Seu modelo é muito grande para a tela",
	"dialog.scale.confirm": "Escala",
	"dialog.plugins.title": "Extensões",
	"dialog.plugins.installed": "Instaladas",
	"dialog.plugins.available": "Disponíveis",
	"dialog.plugins.install": "Instalar",
	"dialog.plugins.uninstall": "Desinstalar",
	"dialog.plugins.reload": "Recarregar",
	"dialog.plugins.none_installed": "Nenhum plugin instalado",
	"dialog.plugins.none_available": "Nenhuma extensão disponível",
	"dialog.plugins.web_only": "Apenas para o aplicativo web",
	"dialog.plugins.app_only": "Apenas para o aplicativo de desktop",
	"dialog.plugins.author": "Criado por %0",
	"dialog.create_texture.folder": "Pasta",
	"dialog.create_texture.resolution": "Resolução",
	"dialog.input.title": "Entrada",
	"dialog.settings.settings": "Configurações",
	"dialog.settings.keybinds": "Atalhos",
	"dialog.settings.about": "Sobre",
	"layout.color.back": "Cor de fundo",
	"layout.color.back.desc": "Planos de fundo e campos de texto",
	"layout.color.dark": "Cor escura",
	"layout.color.dark.desc": "Plano de fundo da tela",
	"layout.color.ui": "Interface",
	"layout.color.ui.desc": "Cor principal da interface",
	"layout.color.bright_ui": "Interface clara",
	"layout.color.bright_ui.desc": "Menus de contexto e dicas",
	"layout.color.button": "Botões",
	"layout.color.button.desc": "Botões e seletores",
	"layout.color.selected": "Seleções",
	"layout.color.selected.desc": "Abas e objetos selecionados",
	"layout.color.border": "Bordas",
	"layout.color.border.desc": "Bordas de botões e campos de texto",
	"layout.color.accent": "Cor de destaque",
	"layout.color.accent.desc": "Botões deslizantes e outros detalhes",
	"layout.color.grid": "Grade",
	"layout.color.grid.desc": "Grade da pré-visualização 3D",
	"layout.color.text": "Texto",
	"layout.color.text.desc": "Texto normal",
	"layout.color.light": "Cor clara",
	"layout.color.light.desc": "Texto destacado",
	"layout.color.accent_text": "Texto em destaque",
	"layout.color.accent_text.desc": "Texto em elementos claros ou destacados",
	"layout.font.main": "Fonte principal",
	"layout.font.headline": "Fonte de títulos",
	"about.version": "Versão:",
	"settings.category.general": "Principal",
	"settings.category.preview": "Pré-visualização",
	"settings.category.grid": "Grade",
	"settings.category.edit": "Edição",
	"settings.category.snapping": "Ajuste",
	"settings.category.defaults": "Padrões",
	"settings.category.dialogs": "Diálogos",
	"settings.category.export": "Exportação",
	"settings.language": "Idioma",
	"settings.language.desc": "Idioma da interface. Reinicie o Blockbench para aplicar as alterações",
	"settings.backup_interval": "Intervalo de salvamento",
	"settings.backup_interval.desc": "Intervalo entre salvamentos automáticos (em minutos)",
	"settings.origin_size": "Origem da rotação",
	"settings.origin_size.desc": "Tamanho da origem da rotação",
	"settings.control_size": "Tamanho do controle de eixos",
	"settings.control_size.desc": "Tamanho da ferramenta de controle de 3 eixos",
	"settings.display_skin": "Mostrar skin",
	"settings.display_skin.desc": "Skin utilizada no modelo de jogador de referência de exibição.",
	"settings.shading": "Sombreamento",
	"settings.shading.desc": "Ativa o sombreamento.",
	"settings.base_grid": "Grade pequena",
	"settings.base_grid.desc": "Mostrar grade pequena e eixos.",
	"settings.large_grid": "Grade grande",
	"settings.large_grid.desc": "Mostrar grade de blocos 16x16.",
	"settings.full_grid": "Grade completa",
	"settings.full_grid.desc": "Mostrar grade precisa em píxel.",
	"settings.large_box": "Caixa grande",
	"settings.large_box.desc": "Mostrar limite de blocos 3x3x3.",
	"settings.display_grid": "Modo exibição",
	"settings.display_grid.desc": "Mostrar grade no modo de exibição.",
	"settings.undo_limit": "Limite de desfazer",
	"settings.undo_limit.desc": "Número de ações que você pode desfazer.",
	"settings.local_move": "Mover nos eixos relativos",
	"settings.local_move.desc": "Mover elementos rotacionados em seus próprios eixos, se possível.",
	"settings.canvas_unselect": "Cancelar seleção ao clicar na tela",
	"settings.canvas_unselect.desc": "Desmarca todos os elementos ao clicar no fundo da tela.",
	"settings.paint_side_restrict": "Restringir pincel à lateral",
	"settings.paint_side_restrict.desc": "Restringe os pincéis para pintar apenas no lado atual.",
	"settings.autouv": "Mapeamento automático",
	"settings.autouv.desc": "Ativa o mapeamento UV automático por padrão,",
	"settings.create_rename": "Renomear novos cubos",
	"settings.create_rename.desc": "Seleciona o campo de nome ao criar um novo elemento ou grupo.",
	"settings.edit_size": "Resolução da grade",
	"settings.edit_size.desc": "Resolução da grade de encaixe dos cubos.",
	"settings.shift_size": "Resolução ao segurar Shift",
	"settings.shift_size.desc": "Resolução da grade ao manter Shift pressionado.",
	"settings.ctrl_size": "Resolução ao segurar Ctrl",
	"settings.ctrl_size.desc": "Resolução da grade ao manter Ctrl pressionado.",
	"settings.negative_size": "Tamanho negativo",
	"settings.negative_size.desc": "Permite que a ferramenta de redimensionamento use tamanhos negativos.",
	"settings.minifiedout": "Exportação simplificada",
	"settings.minifiedout.desc": "Salvar o arquivo JSON em uma única linha.",
	"settings.export_groups": "Exportar grupos",
	"settings.export_groups.desc": "Salvar grupos em modelos de bloco ou item.",
	"settings.credit": "Comentário de crédito",
	"settings.credit.desc": "Adiciona um comentário de crédito aos arquivos exportados.",
	"settings.default_path": "Caminho padrão de texturas do Minecraft",
	"settings.default_path.desc": "Pasta de origem das texturas padrões do Blockbench.",
	"settings.image_editor": "Editor de imagem",
	"settings.image_editor.desc": "Editor de imagens padrão para editar texturas.",
	"category.navigate": "Navegação",
	"category.tools": "Ferramentas",
	"category.file": "Arquivo",
	"category.blockbench": "Blockbench",
	"category.edit": "Editar",
	"category.transform": "Transformar",
	"category.view": "Ver",
	"category.display": "Configurações de exibição",
	"category.textures": "Texturas",
	"category.misc": "Diversos",
	"keybind.preview_select": "Seleção",
	"keybind.preview_rotate": "Rotacionar a visão",
	"keybind.preview_drag": "Arrastar a visão",
	"keybind.confirm": "Confirmar",
	"keybind.cancel": "Cancelar",
	"action.slider_inflate": "Aumentar",
	"action.slider_inflate.desc": "Aumentar cubos em todas as direções sem alterar o mapeamento.",
	"action.slider_brush_size": "Tamanho",
	"action.slider_brush_size.desc": "Tamanho do pincel (em píxeis).",
	"action.slider_brush_opacity": "Opacidade",
	"action.slider_brush_opacity.desc": "Opacidade do pincel (em %).",
	"action.slider_brush_softness": "Suavidade",
	"action.slider_brush_softness.desc": "Suavidade do pincel (em %).",
	"action.uv_slider_pos_x": "Mover horizontalmente",
	"action.uv_slider_pos_x.desc": "Move a seleção UV de todos os cubos selecionados horizontalmente.",
	"action.uv_slider_pos_y": "Mover verticalmente",
	"action.uv_slider_pos_y.desc": "Move a seleção UV de todos os cubos selecionados verticalmente.",
	"action.uv_slider_size_x": "Redimensionar horizontalmente",
	"action.uv_slider_size_x.desc": "Redimensiona a seleção UV de todos os cubos selecionados horizontalmente.",
	"action.uv_slider_size_y": "Redimensionar verticalmente",
	"action.uv_slider_size_y.desc": "Redimensiona verticalmente a seleção UV de todos os cubos selecionados.",
	"action.vertex_snap_mode": "Modo ajuste",
	"action.vertex_snap_mode.desc": "Seleciona se o ajuste a vértices deve mover os elementos para a posição selecionada ou redimensioná-los.",
	"action.move_tool": "Mover",
	"action.move_tool.desc": "Seleciona e move os elementos.",
	"action.resize_tool": "Redimensionar",
	"action.resize_tool.desc": "Seleciona e redimensiona os elementos.",
	"action.brush_tool": "Pincel",
	"action.brush_tool.desc": "Pinta em texturas de bitmap em superfícies ou no editor de UV.",
	"action.vertex_snap_tool": "Ajustar vértices",
	"action.vertex_snap_tool.desc": "Move um cubo para outro conectando dois vértices.",
	"action.swap_tools": "Trocar ferramentas",
	"action.swap_tools.desc": "Alterna entre as ferramentas de mover e redimensionar",
	"action.project_window": "Projeto...",
	"action.project_window.desc": "Abre a janela de projeto para edição dos metadados do seu modelo.",
	"action.open_model": "Abrir modelo",
	"action.open_model.desc": "Abre um arquivo de modelo em seu computador.",
	"action.extrude_texture": "Textura extrudada",
	"action.extrude_texture.desc": "Gera um modelo a partir do esticamento de uma textura.",
	"action.export_blockmodel": "Exportar modelo de bloco ou item",
	"action.export_blockmodel.desc": "Exporta um modelo de bloco ou item do Minecraft Java Edition.",
	"action.export_optifine_part": "Exportar modelo OptiFine",
	"action.export_optifine_part.desc": "Exporta um único modelo de parte de entidade para o OptiFine.",
	"action.export_optifine_full": "Exportar OptiFine JEM",
	"action.export_optifine_full.desc": "Exporta um modelo de entidade completo do OptiFine.",
	"action.export_obj": "Exportar modelo OBJ",
	"action.export_obj.desc": "Exporta um modelo Wavefront OBJ para renderização.",
	"action.settings_window": "Configurações...",
	"action.settings_window.desc": "Abre a janela de configurações do Blockbench.",
	"action.plugins_window": "Extensões...",
	"action.plugins_window.desc": "Abre a janela da loja de plugins",
	"action.reset_layout": "Redefinir aparência",
	"action.reset_layout.desc": "Redefinir a aparência ao padrão do Blockbench",
	"action.load_plugin": "Carregar plugin de um arquivo",
	"action.load_plugin.desc": "Carregar uma extensão importando o arquivo de origem.",
	"action.reload_plugins": "Recarregar plugins",
	"action.reload_plugins.desc": "Recarregar todos os plugins de desenvolvimento.",
	"action.undo": "Desfazer",
	"action.undo.desc": "Desfaz a última alteração.",
	"action.redo": "Refazer",
	"action.redo.desc": "Reverte a última ação desfeita.",
	"action.copy": "Copiar",
	"action.copy.desc": "Copia a seleção, face ou configurações de exibição atuais.",
	"action.paste": "Colar",
	"action.paste.desc": "Cola a seleção, face ou configurações de exibição atuais.",
	"action.cut": "Recortar",
	"action.cut.desc": "Recorta a seleção, face ou configurações de exibição atuais.",
	"action.add_cube": "Adicionar cubo",
	"action.add_cube.desc": "Adiciona um novo cubo.",
	"action.add_group": "Adicionar grupo",
	"action.add_group.desc": "Adiciona um novo grupo ou osso.",
	"action.outliner_toggle": "Mostrar mais opções",
	"action.outliner_toggle.desc": "Mostra opções adicionais no organizador.",
	"action.duplicate": "Duplicar",
	"action.delete": "Apagar",
	"action.sort_outliner": "Ordenar",
	"action.sort_outliner.desc": "Ordena os elementos em ordem alfabética.",
	"action.select_window": "Selecionar...",
	"action.select_window.desc": "Busca e seleciona os cubos com base em suas propriedades.",
	"action.invert_selection": "Inverter seleção",
	"action.invert_selection.desc": "Inverte a seleção atual de cubos",
	"action.select_all": "Selecionar tudo",
	"action.collapse_groups": "Recolher grupos",
	"action.collapse_groups.desc": "Recolhe todos os grupos.",
	"action.scale": "Redimensionar...",
	"action.scale.desc": "Redimensiona os cubos selecionados.",
	"action.toggle_visibility": "Alternar visibilidade",
	"action.toggle_visibility.desc": "Alterna a visibilidade dos cubos selecionados.",
	"action.toggle_export": "Alternar exportação",
	"action.toggle_export.desc": "Alterna as configurações de exportação dos cubos selecionados.",
	"action.toggle_autouv": "Alternar UV auto.",
	"action.toggle_autouv.desc": "Alterna as configurações do UV automático dos cubos selecionados.",
	"action.toggle_shade": "Alternar sombreamento",
	"action.toggle_shade.desc": "Alterna o sombreamento dos cubos selecionados.",
	"action.rename": "Renomear",
	"action.rename.desc": "Mudar o nome dos cubos selecionados.",
	"action.add_display_preset": "Nova predefinição",
	"action.add_display_preset.desc": "Adicionar uma nova predefinição de configuração de exibição.",
	"action.fullscreen": "Tela cheia",
	"action.fullscreen.desc": "Alterna para o modo tela cheia.",
	"action.zoom_in": "Aumentar zoom",
	"action.zoom_in.desc": "Aumenta o zoom para ampliar a interface.",
	"action.zoom_out": "Reduzir zoom",
	"action.zoom_out.desc": "Reduz o zoom para reduzir a interface.",
	"action.zoom_reset": "Redefinir zoom",
	"action.zoom_reset.desc": "Redefine o zoom para o padrão (100%).",
	"action.reset_interface": "Redefinir interface",
	"action.reset_interface.desc": "Redefine o tamanho e as posições da interface.",
	"action.screenshot_model": "Fotografar modelo",
	"action.screenshot_model.desc": "Faz uma captura de tela recortada do modelo do ângulo atual.",
	"action.screenshot_app": "Fotografar aplicativo",
	"action.screenshot_app.desc": "Faz uma captura de tela de toda a aplicação.",
	"action.import_texture": "Importar Textura",
	"action.import_texture.desc": "Importa uma ou mais texturas do seu arquivo do sistema.",
	"action.create_texture": "Criar textura",
	"action.create_texture.desc": "Cria uma textura ou padrão de textura em branco.",
	"action.save_textures": "Salvar texturas",
	"action.save_textures.desc": "Salva as texturas não salvas.",
	"action.animated_textures": "Iniciar Texturas Animadas",
	"action.animated_textures.desc": "Iniciar e pausar a pré-visualização das texturas animadas.",
	"action.origin_to_geometry": "Origem para geometria",
	"action.origin_to_geometry.desc": "Define a origem para o centro da geometria.",
	"action.bone_reset_toggle": "Redefinir osso",
	"action.bone_reset_toggle.desc": "Impedir que o osso exiba cubos do modelo derivador.",
	"action.reload": "Recarregar Blockbench",
	"action.reload.desc": "Recarrega o Blockbench. Isso removerá todos os progressos não salvos.",
	"menu.file": "Arquivo",
	"menu.edit": "Editar",
	"menu.transform": "Transformar",
	"menu.display": "Exibição",
	"menu.view": "Visualizar",
	"menu.file.new": "Novo",
	"menu.file.recent": "Recente",
	"menu.file.import": "Importar",
	"menu.file.export": "Exportar",
	"menu.transform.rotate": "Girar",
	"menu.transform.flip": "Inverter",
	"menu.transform.center": "Centralizar",
	"menu.transform.properties": "Propriedades",
	"menu.display.preset": "Aplicar predefinição",
	"menu.display.preset_all": "Aplicar predefinição em tudo",
	"menu.display.remove_preset": "Remover predefinição",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Plano de fundo",
	"menu.view.screenshot": "Captura de tela",
	"menu.cube.color": "Cor do marcador",
	"menu.cube.texture": "Textura",
	"menu.cube.texture.transparent": "Transparente",
	"menu.cube.texture.blank": "Em branco",
	"menu.group.sort": "Ordenar",
	"menu.texture.face": "Aplicar à face",
	"menu.texture.file": "Arquivo",
	"menu.texture.refresh": "Atualizar",
	"menu.texture.change": "Mudar arquivo",
	"menu.texture.folder": "Abrir na pasta",
	"menu.texture.edit": "Editar",
	"menu.texture.export": "Salvar como",
	"menu.texture.save": "Salvar",
	"menu.texture.properties": "Propriedades...",
	"menu.preview.background": "Plano de fundo",
	"menu.preview.background.load": "Carregar",
	"menu.preview.background.position": "Posição",
	"menu.preview.background.lock": "Bloquear câmera",
	"menu.preview.screenshot": "Captura de tela",
	"menu.preview.perspective": "Perspectiva",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Visão Quádrupla",
	"menu.preview.stop_drag": "Parar posicionamento do plano de fundo",
	"menu.uv.mapping.rotation": "Rotação",
	"menu.uv.texture": "Textura",
	"cube.color.light_blue": "Azul-claro",
	"cube.color.yellow": "Amarelo",
	"cube.color.orange": "Laranja",
	"cube.color.red": "Vermelho",
	"cube.color.purple": "Roxo",
	"cube.color.blue": "Azul",
	"cube.color.green": "Verde",
	"cube.color.lime": "Verde-limão",
	"switches.visibility": "Visibilidade",
	"switches.export": "Exportar",
	"switches.autouv": "UV auto.",
	"panel.uv": "UV",
	"panel.display": "Padrão",
	"panel.textures": "Texturas",
	"panel.outliner": "Organizador",
	"uv_editor.title": "Editor de UV",
	"uv_editor.all_faces": "Todas",
	"uv_editor.no_faces": "Nenhum",
	"face.north": "Norte",
	"face.south": "Sul",
	"face.west": "Oeste",
	"face.east": "Leste",
	"face.up": "Cima",
	"face.down": "Baixo",
	"direction.north": "Norte",
	"direction.south": "Sul",
	"direction.west": "Oeste",
	"direction.east": "Leste",
	"direction.top": "Topo",
	"direction.bottom": "Baixo",
	"display.slot.third_right": "Direita da terceira pessoa",
	"display.slot.third_left": "Esquerda da terceira pessoa",
	"display.slot.first_right": "Direita da primeira pessoa",
	"display.slot.first_left": "Esquerda da primeira pessoa",
	"display.slot.head": "Cabeça",
	"display.slot.ground": "Chão",
	"display.slot.frame": "Quadro",
	"display.slot.gui": "Interface",
	"display.rotation": "Rotação",
	"display.translation": "Translação",
	"display.scale": "Redimensionar",
	"display.slot": "Espaço",
	"display.reference": "Modelo de referência",
	"display.reference.player": "Jogador",
	"display.reference.zombie": "Zumbi",
	"display.reference.armor_stand": "Suporte de armadura",
	"display.reference.baby_zombie": "Zumbi bebê",
	"display.reference.armor_stand_small": "Suporte de armadura pequeno",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Arco",
	"display.reference.block": "Bloco",
	"display.reference.frame": "Moldura",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventário",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Digite um nome",
	"display.preset.item": "Item padrão",
	"display.preset.block": "Bloco padrão",
	"display.preset.handheld": "Arma padrão",
	"display.preset.rod": "Vara padrão",
	"dialog.continue": "Continuar",
	"message.square_textures": "Texturas têm que ser quadradas",
	"message.unsaved_texture.title": "Textura não salva",
	"message.unsaved_texture.message": "Todas as alterações não salvas serão perdidas. Deseja continuar?",
	"action.vertex_snap_mode.move": "Mover",
	"action.vertex_snap_mode.scale": "Redimensionar",
	"action.open_model_folder": "Abrir pasta de modelos",
	"action.open_model_folder.desc": "Abre a pasta onde o modelo está localizado.",
	"action.change_textures_folder": "Mudar local da textura",
	"action.change_textures_folder.desc": "Altera a pasta onde todas as texturas são salvas.",
	"menu.texture.particle": "Usar para partículas",
	"message.update_notification.title": "Não foi possível instalar a atualização",
	"message.update_notification.message": "Uma nova versão do Blockbench está disponível. Ative a opção de atualizações automáticas nas configurações para atualizar!",
	"message.untextured": "Superfície sem textura",
	"dialog.toolbar_edit.title": "Personalizar barra de ferramentas",
	"keybindings.reset": "Redefinir",
	"keybindings.clear": "Vazio",
	"action.cube_counter": "Contador de cubos",
	"action.uv_rotation": "Rotação UV",
	"action.uv_rotation.desc": "Rotação da face UV",
	"action.uv_grid": "Grade UV",
	"action.uv_grid.desc": "Define a resolução de alinhamento da grade para o seletor UV.",
	"action.uv_grid.auto": "Auto.",
	"action.uv_maximize": "Maximizar UV",
	"action.uv_maximize.desc": "Define o UV desta face para a textura total.",
	"action.uv_auto": "UV auto.",
	"action.uv_auto.desc": "Define o tamanho de UV dessa face para o tamanho real da face.",
	"action.uv_rel_auto": "UV relativo auto.",
	"action.uv_rel_auto.desc": "Define o UV dessa face para a posição e tamanho da face real.",
	"action.uv_mirror_x": "Espelhar UV no eixo X",
	"action.uv_mirror_x.desc": "Espelha o UV da face no eixo X.",
	"action.uv_mirror_y": "Espelhar UV no eixo Y",
	"action.uv_mirror_y.desc": "Espelha o UV da face no eixo Y.",
	"action.uv_transparent": "Remover face",
	"action.uv_transparent.desc": "Remove a face atual.",
	"action.uv_reset": "Redefinir face",
	"action.uv_reset.desc": "Redefine a face atual.",
	"action.cullface": "Face coberta",
	"action.cullface.desc": "Desativa a renderização para essa face se o lado selecionado do modelo for coberto.",
	"action.auto_cullface": "Cobrir face auto.",
	"action.auto_cullface.desc": "Define a cobertura de face para ela mesma.",
	"action.face_tint": "Matiz",
	"action.face_tint.desc": "Ative a opção de matiz para a face atual.",
	"menu.toolbar.edit": "Personalizar",
	"menu.toolbar.reset": "Redefinir",
	"uv_editor.rotated": "Girado",
	"uv_editor.auto_cull": "Cobrir face",
	"uv_editor.copied": "Face copiada",
	"uv_editor.pasted": "Face colada",
	"uv_editor.copied_x": "%0 faces copiadas",
	"uv_editor.reset": "Redefinir face",
	"uv_editor.maximized": "Maximizado",
	"uv_editor.autouv": "Tamanho automático",
	"uv_editor.mirrored": "Espelhado",
	"uv_editor.to_all": "Aplicado para todas as faces",
	"uv_editor.transparent": "Tornar transparente",
	"uv_editor.cullface_on": "Face oculta ligada",
	"uv_editor.cullface_off": "Face oculta desligada",
	"uv_editor.tint_on": "Matiz ligado",
	"uv_editor.tint_off": "Matiz desligado",
	"action.uv_apply_all": "Aplicar para todas as faces",
	"action.uv_apply_all.desc": "Aplica as configurações na face atual e para todas as faces",
	"message.image_editor_missing.title": "Editor de imagem padrão",
	"message.image_editor_missing.message": "Seleciona o arquivo executável em seu editor de imagem",
	"message.image_editor_missing.detail": "O Blockbench não encontrou um editor de imagens em seu computador. Selecione o arquivo executável em um editor de imagens de sua preferência.",
	"action.update_autouv": "Atualizar UV auto.",
	"action.update_autouv.desc": "Atualiza o UV automático mapeando os cubos selecionados",
	"category.uv": "UV",
	"status_bar.saved": "Modelo salvo",
	"status_bar.unsaved": "Há alterações não salvas",
	"action.move_up": "Mover para cima",
	"action.move_up.desc": "Move os cubos selecionados para cima em relação ao ângulo atual da câmera.",
	"action.move_down": "Mover para baixo",
	"action.move_down.desc": "Move os cubos selecionados para baixo em relação ao ângulo atual da câmera.",
	"action.move_left": "Mover para esquerda",
	"action.move_left.desc": "Move os cubos selecionados para a esquerda em relação ao ângulo atual da câmera.",
	"action.move_right": "Mover para direita",
	"action.move_right.desc": "Move os cubos selecionados para a direita em relação ao ângulo atual da câmera.",
	"action.move_forth": "Mover para frente",
	"action.move_forth.desc": "Mover os cubos selecionados para a frente em relação ao ângulo atual da câmera.",
	"action.move_back": "Mover para trás",
	"action.move_back.desc": "Move os cubos selecionados para atrás em relação ao ângulo atual da câmera.",
	"layout.color.wireframe": "Estrutura de arame",
	"layout.color.wireframe.desc": "Linhas da estrutura de arame.",
	"action.add_animation": "Adicionar animação",
	"action.add_animation.desc": "Cria uma animação em branco.",
	"action.load_animation_file": "Importar animações",
	"action.load_animation_file.desc": "Importa um arquivo de animação.",
	"action.play_animation": "Iniciar animação",
	"action.play_animation.desc": "Pré-visualizar animação.",
	"action.slider_keyframe_time": "Tempo",
	"action.slider_keyframe_time.desc": "Altera o tempo dos quadros selecionados.",
	"timeline.rotation": "Rotação",
	"timeline.position": "Posição",
	"timeline.scale": "Redimensionar",
	"menu.keyframe.quaternion": "Quaternião",
	"panel.animations": "Animações",
	"panel.keyframe": "Quadro",
	"panel.keyframe.type": "Quadro (%0)",
	"generic.delete": "Apagar",
	"generic.rename": "Renomear",
	"message.no_animation_selected": "Selecione uma animação para fazer isso",
	"message.no_bone_selected": "Selecione um osso para fazer isso",
	"message.duplicate_groups.title": "Nome do osso duplicado",
	"message.duplicate_groups.message": "Esse nome já existe em vários outros ossos. Isso pode causar problemas.",
	"action.delete_keyframes": "Apagar quadros",
	"action.delete_keyframes.desc": "Apaga todos os quadros selecionados.",
	"menu.animation": "Animação",
	"menu.animation.loop": "Modo loop",
	"menu.animation.override": "Sobrescrever",
	"menu.animation.anim_time_update": "Atualizar tempo de animação",
	"message.display_skin_model.title": "Modelo da skin",
	"message.display_skin_model.message": "Seleciona o tipo de modelo da sua skin",
	"message.display_skin_model.classic": "Clássica",
	"message.display_skin_model.slim": "Fina",
	"message.bone_material": "Mudar material do osso",
	"action.slider_animation_length": "Duração da animação",
	"action.slider_animation_length.desc": "Altera a duração da animação selecionada",
	"panel.variable_placeholders": "Preenchedores de Espaço de Variáveis",
	"panel.variable_placeholders.info": "Lista as variáveis ​​que você deseja visualizar via nome=valor",
	"status_bar.vertex_distance": "Distância: %0",
	"dialog.create_gif.title": "Gravar GIF",
	"dialog.create_gif.length": "Duração",
	"dialog.create_gif.fps": "QPS",
	"dialog.create_gif.play": "Iniciar animação",
	"category.animation": "Animação",
	"action.record_model_gif": "Gravar GIF",
	"action.record_model_gif.desc": "Grava um GIF animado do modelo do ângulo atual.",
	"display.mirror": "Espelhar",
	"data.separator": "Separador",
	"menu.preview.background.set_position": "Definir posição",
	"dialog.toolbar_edit.hidden": "Escondido",
	"action.export_class_entity": "Exportar entidade java",
	"action.export_class_entity.desc": "Exporta o modelo da entidade como uma classe Java.",
	"settings.seethrough_outline": "Contornos em raio-x",
	"settings.seethrough_outline.desc": "Mostrar contornos dos objetos.",
	"mode.edit": "Editar",
	"mode.paint": "Pintar",
	"mode.display": "Mostrar",
	"mode.animate": "Animar",
	"status_bar.recording_gif": "Gravando GIF",
	"status_bar.processing_gif": "Processando GIF",
	"settings.backup_retain": "Duração do armazenamento de backups",
	"settings.backup_retain.desc": "Defina por quantos dias o Blockbench deverá manter os backups antigos.",
	"action.rotate_tool": "Girar",
	"action.rotate_tool.desc": "Seleciona e gira elementos.",
	"action.fill_tool": "Balde de tinta",
	"action.fill_tool.desc": "Preenche as faces inteiras com uma cor.",
	"action.eraser": "Borracha",
	"action.eraser.desc": "Substitui as cores por uma textura transparente.",
	"action.color_picker": "Seletor de cores",
	"action.color_picker.desc": "Escolhe a cor dos píxeis na sua textura.",
	"switches.mirror": "Espelhar UV",
	"language_name": "Português (Brasil)",
	"message.plugin_reload": "%0 plugins locais recarregadas",
	"settings.brightness": "Brilho",
	"settings.brightness.desc": "Brilho de pré-visualização. O valor padrão do brilho é 50.",
	"menu.preview.perspective.reset": "Redefinir câmera",
	"action.fill_mode": "Modo preenchimento",
	"action.fill_mode.face": "Face",
	"action.fill_mode.color": "Cores",
	"action.toggle_mirror_uv": "Espelhar UV",
	"action.toggle_mirror_uv.desc": "Alterna a inversão do UV no eixo X dos cubos selecionados.",
	"menu.texture.blank": "Aplicar às faces sem texturas",
	"dialog.scale.select_overflow": "Selecionar excesso",
	"action.action_control": "Controle de ação",
	"action.action_control.desc": "Pesquisa e executa qualquer ação disponível.",
	"keybindings.recording": "Gravando tecla de atalho",
	"keybindings.press": "Pressione, combine ou clique em qualquer lugar da tela para salvar a(s) tecla(s) de sua preferência.",
	"action.pivot_tool": "Ferramenta pivô",
	"action.pivot_tool.desc": "Altera o ponto de articulação de cubos e ossos.",
	"action.slider_animation_speed": "Velocidade de reprodução",
	"action.slider_animation_speed.desc": "Velocidade de reprodução da linha do tempo em porcentagem.",
	"action.previous_keyframe": "Quadro anterior",
	"action.previous_keyframe.desc": "Pular para o quadro anterior.",
	"action.next_keyframe": "Próximo quadro",
	"action.next_keyframe.desc": "Pular para o próximo quadro.",
	"message.outdated_client.title": "Cliente desatualizado",
	"message.outdated_client.message": "Atualize o Blockbench para a versão mais recente para fazer isso.",
	"action.export_asset_archive": "Baixar pacote",
	"action.export_asset_archive.desc": "Baixe um pacote que tenha o modelo e todas as texturas.",
	"action.upload_sketchfab": "Enviar para o Sketchfab…",
	"message.sketchfab.name_or_token": "Digite seu token e o nome do Sketchfab",
	"dialog.sketchfab_uploader.title": "Enviar modelo Sketchfab",
	"dialog.sketchfab_uploader.token": "Token de API",
	"dialog.sketchfab_uploader.about_token": "O token é usado para conectar o Blockbench à sua conta do Sketchfab. Você pode encontrá-lo em %0",
	"dialog.sketchfab_uploader.name": "Nome do modelo",
	"dialog.sketchfab_uploader.description": "Descrição",
	"dialog.sketchfab_uploader.tags": "Marcadores",
	"settings.sketchfab_token": "Token do Sketchfab",
	"settings.sketchfab_token.desc": "Token para autorizar o Blockbench a enviar modelos para a sua conta Sketchfab.",
	"panel.color": "Cor",
	"data.origin": "Origem",
	"message.sketchfab.success": "Envio do modelo realizado",
	"message.sketchfab.error": "Falha ao enviar o modelo para o Sketchfab",
	"settings.outliner_colors": "Cores do organizador",
	"settings.outliner_colors.desc": "Mostrar cores de elementos e grupos no organizador.",
	"action.upload_sketchfab.desc": "Envia seu modelo para o Sketchfab.",
	"action.element_colors": "Cores de cubos",
	"action.element_colors.desc": "Mostrar cores de cubos no organizador.",
	"texture.error.file": "Arquivo não encontrado",
	"texture.error.parent": "Arquivo de textura dado pelo modelo derivador",
	"message.recover_backup.title": "Recuperar modelo",
	"message.recover_backup.message": "Blockbench foi fechado sem salvar. Deseja recuperar o modelo?",
	"message.invalid_session.title": "Token de sessão inválido",
	"message.invalid_session.message": "A sessão que você está tentando acessar expirou ou o token fornecido é inválido.",
	"dialog.create_texture.power": "Tamanho em potência de dois",
	"dialog.create_gif.turn": "Velocidade da mesa giratória",
	"action.edit_session": "Sessão de edição...",
	"action.edit_session.desc": "Conecte-se a uma sessão de edição para colaborar com outros usuários.",
	"action.reset_keyframe": "Redefinir quadro",
	"action.reset_keyframe.desc": "Redefine todos os valores dos quadros selecionados.",
	"dialog.edit_session.title": "Sessão de Edição",
	"edit_session.username": "Nome de usuário",
	"edit_session.token": "Token",
	"edit_session.about": "As sessões de edição podem ser usadas para colaborar em modelos pela internet. Crie uma sessão, copie o token e envie-o aos seus amigos que poderão usá-lo para entrar.",
	"edit_session.join": "Entrar na sessão",
	"edit_session.create": "Criar sessão",
	"edit_session.quit": "Sair da sessão",
	"edit_session.joined": "%0 entrou na sessão",
	"edit_session.left": "%0 saiu da sessão",
	"edit_session.quit_session": "Saiu da sessão atual",
	"edit_session.status": "Status",
	"edit_session.hosting": "Hospedando",
	"edit_session.connected": "Conectado a uma sessão",
	"dialog.sketchfab_uploader.private": "Privado (Pro)",
	"dialog.sketchfab_uploader.password": "Senha (Pro)",
	"action.uv_select_all": "Selecionar tudo",
	"action.uv_select_all.desc": "Seleciona todas as faces no diálogo de UV.",
	"panel.chat": "Bate-papo",
	"edit_session.welcome": "Bem-vindo(a) à sessão de %0",
	"dialog.yes": "Sim",
	"dialog.no": "Não",
	"generic.remove": "Remover",
	"generic.download": "Baixar",
	"generic.search": "Pesquisa",
	"dates.today": "Hoje",
	"dates.yesterday": "Ontem",
	"dates.this_week": "Esta semana",
	"dates.weeks_ago": "Há %0 semanas",
	"mode.start.new": "Novo",
	"mode.start.recent": "Recente",
	"format.free": "Modelo padrão",
	"format.free.desc": "Modelo sem restrições. Para motores de jogos, renderização etc.",
	"format.java_block": "Bloco/Item Java",
	"format.java_block.desc": "Modelo de bloco ou item para a edição Java.",
	"format.bedrock": "Modelo Bedrock",
	"format.bedrock.desc": "Modelo para Minecraft: Bedrock Edition",
	"format.bedrock_old": "Modelo legado para a Bedrock Edition",
	"format.bedrock_old.desc": "Modelo de entidade para o Minecraft: Bedrock Edition (Pré-1.12)",
	"format.modded_entity": "Entidade modificada",
	"format.modded_entity.desc": "Modelos de entidade para mods. Pode ser exportado como arquivos .java class.",
	"format.optifine_entity": "Entidade OptiFine",
	"format.optifine_entity.desc": "Modelo personalizado de entidade para OptiFine.",
	"keys.mouse": "Botão do mouse: %0",
	"message.cleared_blank_faces.title": "Faces em branco",
	"message.cleared_blank_faces.message": "O Blockbench encontrou %0 cubo(s) sem nenhuma textura. Deseja remover esse(s) elemento(s)?",
	"message.wireframe.enabled": "Visualização de estrutura de arame ativada",
	"message.wireframe.disabled": "Visualização de estrutura de arame desativada",
	"dialog.convert_project.title": "Converter projeto",
	"dialog.create_texture.double_use": "Manter ocupação de textura múltipla",
	"dialog.model_stats.title": "Status do modelo",
	"dialog.model_stats.cubes": "Cubos",
	"dialog.model_stats.locators": "Localizadores",
	"dialog.model_stats.groups": "Grupos",
	"dialog.model_stats.vertices": "Vértices",
	"dialog.model_stats.faces": "Faces",
	"settings.username": "Nome de usuário",
	"settings.username.desc": "Nome de usuário para as sessões de edição.",
	"settings.painting_grid": "Grade de pintura",
	"settings.painting_grid.desc": "Mostra a grade em cubos texturizados no modo pintura.",
	"action.convert_project": "Converter projeto",
	"action.convert_project.desc": "Converte o projeto atual em um projeto para outro formato de modelo.",
	"action.close_project": "Fechar projeto",
	"action.close_project.desc": "Fecha o projeto aberto.",
	"action.export_bedrock": "Exportar geometria Bedrock",
	"action.export_bedrock.desc": "Exporte o modelo como um arquivo de geometria da Bedrock Edition.",
	"action.save_project": "Salvar projeto",
	"action.save_project.desc": "Salva o modelo atual como um arquivo de projeto.",
	"action.save_project_as": "Salvar projeto como...",
	"action.save_project_as.desc": "Salva o modelo atual como um arquivo de projeto em um novo local.",
	"action.export_over": "Substituir modelo",
	"action.export_over.desc": "Salva o modelo, texturas e animações substituindo os arquivos.",
	"action.add_locator": "Adicionar localizador",
	"action.add_locator.desc": "Adiciona um novo localizador para controlar posições de partículas, cordas etc.",
	"action.uv_turn_mapping": "Mapeamento de giros",
	"action.uv_turn_mapping.desc": "Gire o mapeamento UV em cerca de 90 graus.",
	"action.remove_blank_faces": "Remover faces em branco",
	"action.remove_blank_faces.desc": "Apaga todas as faces não texturizadas da seleção.",
	"web.download_app": "Baixar aplicativo",
	"uv_editor.turned": "Mapeamento ativado",
	"display.reference.crossbow": "Besta",
	"dialog.settings.search_results": "Buscar resultados",
	"settings.animation_snap": "Encaixe de animação",
	"settings.animation_snap.desc": "Intervalo de encaixe padrão para quadros-chave na linha do tempo da animação, em passos por segundo. Isso também pode ser alterado por animação. O valor padrão é 24.",
	"action.import_optifine_part": "Importar parte OptiFine",
	"action.import_optifine_part.desc": "Importa uma parte de modelo de entidade para o OptiFine.",
	"data.locator": "Localizador",
	"mode.start.no_recents": "Nenhum modelo aberto recentemente",
	"panel.element": "Elemento",
	"panel.element.position": "Posição",
	"panel.element.size": "Tamanho",
	"panel.element.origin": "Ponto de Pivô",
	"panel.element.rotation": "Rotação",
	"message.canvas_limit_error.title": "Erro de limite de tela",
	"message.canvas_limit_error.message": "A ação não pôde ser executada corretamente porque o formato limita a área de trabalho a 48 unidades. Desloque o ponto de pivô para evitar isso.",
	"data.effect": "Efeito",
	"generic.name": "Nome",
	"settings.recent_projects": "Limite de modelo recente",
	"settings.recent_projects.desc": "Número máximo de modelos recentes a serem lembrados.",
	"settings.volume": "Volume",
	"settings.volume.desc": "Controle o volume dos efeitos sonoros em animações.",
	"action.clear_timeline": "Limpar linha do tempo",
	"action.clear_timeline.desc": "Limpar todos os ossos não selecionados da linha do tempo.",
	"action.select_effect_animator": "Efeitos animados",
	"action.select_effect_animator.desc": "Abre a linha do tempo para adicionar sons e efeitos de partículas.",
	"action.timeline_focus": "Filtrar canais",
	"action.timeline_focus.desc": "Selecione os canais de animação para mostrar na linha do tempo.",
	"timeline.particle": "Partícula",
	"timeline.sound": "Som",
	"timeline.effects": "Efeitos",
	"data.format": "Formato",
	"format.optifine_part": "Parte de OptiFine",
	"format.optifine_part.desc": "Parte JPM para modelos de entidade OptiFine.",
	"action.reverse_keyframes": "Quadros reversos",
	"action.reverse_keyframes.desc": "Inverte a ordem dos quadros selecionados.",
	"generic.help": "Ajuda",
	"message.removed_faces": "%0 faces removidas",
	"dialog.sketchfab_uploader.draft": "Rascunho",
	"action.slider_pos": "Mover %0",
	"action.slider_pos.desc": "Move os cubos no eixo %0",
	"action.slider_size": "Tamanho %0",
	"action.slider_size.desc": "Redimensiona os cubos no eixo %0.",
	"action.slider_rotation": "Girar %0",
	"action.slider_rotation.desc": "Gira os cubos no eixo %0",
	"action.slider_origin": "Pivô %0",
	"action.slider_origin.desc": "Move o pivô no eixo %0",
	"action.rotate_cw": "Girar %0 +90",
	"action.rotate_cw.desc": "Gira os cubos selecionados 90° no eixo %0",
	"action.rotate_ccw": "Girar %0 -90",
	"action.rotate_ccw.desc": "Gira os cubos selecionados -90° no eixo %0",
	"action.flip": "Virar %0",
	"action.flip.desc": "Vira os cubos selecionados no eixo %0",
	"action.center": "Centro %0",
	"action.center.desc": "Centraliza os cubos selecionados no eixo %0",
	"action.bring_up_all_animations": "Mostrar todos os animadores",
	"panel.bone": "Osso",
	"data.color": "Cor",
	"generic.export": "Exportar",
	"generic.none": "Nenhum",
	"status_bar.recording": "Linha do tempo da gravação",
	"message.add_to_palette": "Adicionado à paleta",
	"message.size_modifiers": "Mantenha pressionada a tecla Ctrl ou Shift para transformar em incrementos menores.",
	"message.timelapse_start": "Timelapse iniciado",
	"message.timelapse_stop": "Timelapse parado",
	"message.import_palette.replace_palette": "Substituir paleta antiga",
	"message.import_palette.threshold": "Limiar de mesclagem",
	"dialog.timelapse.interval": "Intervalo (segundos)",
	"dialog.timelapse.source": "Fonte",
	"dialog.timelapse.source.interface": "Interface",
	"dialog.timelapse.source.locked": "Ângulo bloqueado",
	"dialog.timelapse.destination": "Pasta de destino",
	"layout.color.checkerboard": "Matriz",
	"layout.color.checkerboard.desc": "Fundo de tela e editor UV.",
	"layout.font.code": "Código da fonte",
	"layout.css": "CSS personalizado",
	"settings.category.paint": "Pintar",
	"settings.deactivate_size_limit": "Desativar limite de tamanho",
	"settings.deactivate_size_limit.desc": "Desativa o limite de tamanho para formatos de modelo específicos. AVISO: Isso pode causar modelos inválidos.",
	"settings.brush_opacity_modifier": "Modificador de opacidade do pincel",
	"settings.brush_opacity_modifier.desc": "Modifica a opacidade do pincel ao usar uma caneta.",
	"settings.brush_size_modifier": "Modificador de tamanho de pincel",
	"settings.brush_size_modifier.desc": "Modifica o tamanho do pincel ao usar uma caneta",
	"settings.brush_modifier.pressure": "Pressão",
	"settings.brush_modifier.tilt": "Inclinar",
	"category.color": "Cor",
	"action.import_theme": "Importar tema",
	"action.export_theme": "Exportar tema",
	"action.export_theme.desc": "Cria um arquivo de tema com base nas configurações atuais.",
	"action.slider_color_h": "Matiz",
	"action.slider_color_s": "Saturação",
	"action.slider_color_v": "Valor",
	"action.add_to_palette": "Adicionar à paleta",
	"action.add_to_palette.desc": "Adicione a cor selecionada à paleta de cores.",
	"action.import_palette": "Importar paleta",
	"action.import_palette.desc": "Importar um ficheiro .bbpalette.",
	"action.export_palette": "Exportar paleta",
	"action.export_palette.desc": "Exportar a paleta com um arquivo .bbpalette.",
	"action.generate_palette": "Gerar paleta",
	"action.generate_palette.desc": "Gera a paleta a partir de uma textura.",
	"action.sort_palette": "Classificar paleta",
	"action.sort_palette.desc": "Classifica todas as cores da paleta por cor e brilho.",
	"action.timelapse": "Timelapse...",
	"action.timelapse.desc": "Grave um timelapse do seu progresso de modelagem.",
	"action.add_keyframe": "Adicionar quadro-chave",
	"action.add_keyframe.desc": "Adicione automaticamente um quadro-chave. Pressione shift para forçar os valores padrão.",
	"action.bring_up_all_animations.desc": "Traz todos os animadores modificados para a linha do tempo.",
	"timeline.timeline": "Instruções",
	"menu.palette.load.default": "Padrão",
	"generic.import": "Importar",
	"settings.brush_modifier.none": "Nenhum",
	"action.export_entity": "Exportar entidade Bedrock",
	"action.export_entity.desc": "Inclua o modelo atual como uma entidade em um arquivo mobs.json.",
	"settings.highlight_cubes": "Destacar cubos",
	"settings.highlight_cubes.desc": "Realce os cubos quando você passa o mouse sobre eles ou os seleciona.",
	"action.add_marker": "Definir marcador",
	"action.add_marker.desc": "Define um marcador na linha do tempo.",
	"timeline.pre_effect_script": "Roteiro",
	"format.skin": "Skin do Minecraft",
	"format.skin.desc": "Edite skins de jogadores e entidades.",
	"message.sketchfab.setup_guide": "Deseja aprender a como configurar seus modelos no Sketchfab? Saiba mais em %0",
	"dialog.skin.title": "Criar skin do Minecraft",
	"dialog.skin.model": "Modelo",
	"action.toggle_skin_layer": "Alterar camada da skin",
	"action.toggle_skin_layer.desc": "Altera a camada do chapéu e da roupa do modelo da skin.",
	"action.gui_light": "Luz da GUI",
	"action.gui_light.desc": "Selecione a maneira como o item é iluminado no inventário.",
	"action.gui_light.side": "Luz lateral",
	"action.gui_light.front": "Luz frontal",
	"action.move_keyframe_back": "Mover quadros para trás",
	"action.move_keyframe_forth": "Mover quadros para frente",
	"menu.help": "Ajuda\n",
	"menu.help.discord": "Servidor no Discord",
	"menu.help.report_issue": "Relatar um erro",
	"menu.help.plugin_documentation": "Documentação Plugin API",
	"menu.help.search_action": "Buscar e executar uma ação",
	"menu.help.donate": "Doar",
	"menu.help.about": "Sobre...",
	"menu.preview.background.clipboard": "Carregar da área de transferência",
	"dialog.ignore": "Ignorar",
	"generic.unset": "Desativar",
	"message.invalid_builtin_parent.title": "Derivador integrado interno inválido",
	"message.invalid_builtin_parent.message": "O link para o modelo derivador inválido '%0' foi removido para exportar um modelo válido.",
	"dialog.resize_texture.fill": "Preencher com",
	"dialog.resize_texture.fill.transparent": "Transparente",
	"dialog.resize_texture.fill.color": "Cor",
	"dialog.resize_texture.fill.repeat": "Repetir",
	"dialog.scale.element_pivot": "Elemento do pivô",
	"dialog.scale.selection_center": "Centro de seleção",
	"dialog.create_gif.length_mode": "Modo comprimento",
	"dialog.create_gif.length_mode.seconds": "Segundos",
	"dialog.create_gif.length_mode.frames": "Quadros",
	"dialog.create_gif.length_mode.animation": "Comprimento da animação",
	"dialog.create_gif.length_mode.turntable": "Rotação de mesa giratória",
	"dialog.save_angle.projection": "Projeção",
	"dialog.save_angle.projection.perspective": "Perspectiva",
	"dialog.save_angle.projection.orthographic": "Ortográfico",
	"dialog.sketchfab_uploader.animations": "Animações",
	"dialog.settings.theme": "Tema",
	"settings.category.interface": "Interface",
	"settings.preview_checkerboard": "Mostrar matriz",
	"settings.preview_checkerboard.desc": "Alterna o plano de fundo da matriz por trás da visualização",
	"settings.uv_checkerboard": "Editor UV da matriz",
	"settings.uv_checkerboard.desc": "Alterna o fundo da matriz por trás do editor UV",
	"category.paint": "Pintar",
	"action.fill_mode.color_connected": "Cores conectadas",
	"action.draw_shape_type": "Tipo da forma",
	"action.draw_shape_type.rectangle": "Retângulo",
	"action.draw_shape_type.rectangle_h": "Retângulo (vazio)",
	"action.draw_shape_type.ellipse": "Elipse",
	"action.draw_shape_type.ellipse_h": "Elipse (vazia)",
	"action.draw_shape_type.line": "Linha",
	"action.mirror_painting": "Pintura espelhada",
	"action.mirror_painting.description": "Espelhe seus traços de tinta para o outro lado do modelo.",
	"action.lock_alpha": "Bloquear canal alfa",
	"action.lock_alpha.description": "Bloqueia a transparência de todos os píxeis",
	"action.draw_shape_tool": "Desenhar forma",
	"action.draw_shape_tool.desc": "Desenha formas simples em texturas",
	"action.export_gltf": "Exportar como modelo glTF",
	"action.export_gltf.desc": "Exporta modelo e animações como arquivo glTF para usar em outros aplicativos 3D.",
	"action.transform_space": "Transformar espaço",
	"action.transform_space.desc": "Espaço de transformação padrão para elementos e ossos",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Local",
	"action.toggle_camera_projection": "Alternar projeção de câmera",
	"action.toggle_camera_projection.desc": "Alterna a projeção da câmera entre perspectiva e ortografia",
	"action.load_camera_angle": "Ângulo de câmera: %0",
	"action.load_camera_angle.desc": "Carrega o ângulo '%0' da câmera ",
	"action.slider_face_tint": "Índice de matiz",
	"action.slider_face_tint.desc": "Defina o índice de matiz da face atual. O valor '-1' significa indefinido.",
	"menu.help.quickstart": "Guia rápido para iniciantes",
	"menu.help.developer": "Desenvolvedor",
	"menu.help.developer.dev_tools": "Úteis para desenvolvedor",
	"menu.help.developer.reset_storage": "Restaurar o Blockbench",
	"menu.help.developer.reset_storage.confirm": "Deseja mesmo redefinir o Blockbench? Essa ação apagará as configurações personalizadas, combinações de teclas e plugins instalados.",
	"menu.help.developer.cache_reload": "Recarregar cache",
	"menu.preview.orthographic": "Ortográfico",
	"menu.preview.save_angle": "Salvar ângulo",
	"menu.preview.angle": "Ângulos",
	"menu.preview.angle.initial": "Ângulo inicial",
	"menu.preview.maximize": "Maximizar",
	"uv_editor.copy_selection": "Copiar seleção",
	"uv_editor.paste_selection": "Colar seleção",
	"uv_editor.copy_paste_tool.place": "Colocar",
	"uv_editor.copy_paste_tool.mirror_x": "Espelhar eixo X",
	"uv_editor.copy_paste_tool.mirror_y": "Espelhar eixo Y",
	"uv_editor.copy_paste_tool.rotate": "Girar 90º",
	"dialog.project.modded_entity_version": "Versão de exportação",
	"dialog.save_angle.position": "Posição da câmera",
	"dialog.save_angle.target": "Ponto focal",
	"dialog.skin.pose": "Pose",
	"layout.color.frame": "Moldura da janela",
	"layout.color.frame.desc": "Borda e barra de título da janela.",
	"settings.large_grid_size": "Tamanho da grade do bloco",
	"settings.large_grid_size.desc": "Tamanho da grade do bloco.",
	"action.load_plugin_from_url": "Carregar plugin por URL",
	"action.load_plugin_from_url.desc": "Carrega plugin de um servidor especificando a URL.",
	"action.cube_counter.desc": "Mostra o número atual de cubos e outras estatísticas.",
	"action.unlock_everything": "Desbloquear tudo",
	"action.unlock_everything.desc": "Desbloquea todos os grupos e elementos no organizador.",
	"action.load_palette": "Carregar paleta",
	"action.load_palette.desc": "Carregue uma das predefinições da paleta incorporada.",
	"action.toggle_locked": "Alternar bloqueio",
	"action.toggle_locked.desc": "Alterna se os elementos selecionados estão bloqueados.",
	"action.apply_display_preset": "Aplicar padrão",
	"action.apply_display_preset.desc": "Aplica uma predefinição de configuração de exibição padrão ou personalizada.",
	"action.apply_display_preset.here": "Aplicar para esse espaço",
	"action.apply_display_preset.everywhere": "Aplicar para todos os espaços",
	"action.resolve_keyframe_expressions": "Resolver quadro-chave",
	"action.resolve_keyframe_expressions.desc": "Resolve as expressões matemáticas dos quadros selecionados.",
	"action.fold_all_animations": "Dobre todos os animadores",
	"menu.palette.load.empty": "Vazia",
	"switches.lock": "Bloquear",
	"settings.render_sides": "Lados carregados",
	"settings.render_sides.desc": "Selecione qual lado de uma face é carregado.",
	"settings.render_sides.auto": "Auto.",
	"settings.render_sides.front": "Fora",
	"settings.render_sides.double": "Dentro e fora",
	"generic.enable": "Ativar",
	"generic.disable": "Desativar",
	"generic.redacted": "Editado",
	"dialog.select_texture.import_all": "Importar tudo",
	"dialog.skin.layer_template": "Textura da camada",
	"about.version.up_to_date": "Mais recente",
	"about.version.update_available": "Versão %o disponível",
	"settings.category.application": "Aplicações",
	"settings.streamer_mode": "Modo transmissão",
	"settings.streamer_mode.desc": "Esconder informações sensíveis como modelos recentes",
	"settings.automatic_updates": "Atualizações automáticas",
	"settings.automatic_updates.desc": "Download automático de novas versões e manter BlockBench com a versão mais recente",
	"action.rotation_space": "Espaço de rotação",
	"action.focus_on_selection": "Centralizar o campo visual na seleção",
	"action.focus_on_selection.desc": "Alinhar a câmera para olhar o centro da seleção atual.",
	"action.jump_to_timeline_start": "Pular para o início da animação",
	"action.jump_to_timeline_end": "Pular para o fim da animação",
	"menu.help.updating": "Atualizando (%0%)",
	"menu.help.update_failed": "Falha ao atualizar",
	"menu.animation.loop.once": "Reproduzir uma vez",
	"menu.animation.loop.hold": "Manter no último quadro",
	"menu.animation.loop.loop": "Loop",
	"interface.streamer_mode_on": "Modo transmissão ativado",
	"generic.reset": "Reiniciar",
	"generic.restore": "Restaurar",
	"keys.mousewheel": "Botão de rolagem",
	"message.delete_animation.title": "Animação apagada",
	"message.delete_animation.message": "Animação removida do Blockbench. Deseja apagar a animação do arquivo onde estava salva?",
	"message.no_animation_to_import": "Nenhuma animação para importar",
	"dialog.material_instances.title": "Material",
	"dialog.animation_import.title": "Selecionar animações para importar",
	"dialog.create_texture.padding": "Preenchimento",
	"settings.fov": "CAMPO VISUAL",
	"settings.fov.desc": "Campo visual da câmera. O valor padrão é 45",
	"settings.minify_bbmodel": "Reduzir arquivos do projeto",
	"settings.minify_bbmodel.desc": "Escreve arquivos .bbmodel reduzidos em uma linha.",
	"action.edit_material_instances": "Editar materiais",
	"action.edit_material_instances.desc": "Editar nomes dos materiais para blocos Bedrock.",
	"action.save_all_animations": "Salvar todas as animações",
	"action.save_all_animations.desc": "Salvar todas as animações carregadas.",
	"action.keyframe_interpolation": "Interpolação",
	"action.keyframe_interpolation.desc": "Selecione o modo de interpolação do quadro.",
	"action.keyframe_interpolation.linear": "Linear",
	"action.keyframe_interpolation.catmullrom": "Suavizar",
	"action.timeline_focus.hide_empty": "Esconder canais vazios",
	"menu.file.preferences": "Preferências",
	"menu.animation.blend_weight": "Força da mesclagem",
	"menu.animation.save": "Salvar",
	"menu.animation.properties": "Propriedades...",
	"menu.animation.file": "Arquivo",
	"menu.animation.snapping": "Encaixar",
	"menu.animation.open_location": "Abrir local do arquivo",
	"panel.keyframe.add_data_point": "Adicionar ponto de dados do quadro",
	"panel.keyframe.remove_data_point": "Remover ponto de dados do quadro",
	"panel.keyframe.pre": "Pré",
	"panel.keyframe.post": "Pós",
	"generic.all": "Todos",
	"message.small_face_dimensions.title": "Dimensões de face incompatíveis",
	"message.small_face_dimensions.message": "A seleção tem faces que são menores do que 1 unidade em uma direção. O sistema de mapeamento UV por Caixa considera quaisquer faces abaixo desse limite como tendo 0 píxeis de largura. Por isso, a textura nessas faces pode não funcionar corretamente.",
	"message.small_face_dimensions.face_uv": "O formato atual suporta mapas UV por face, que podem lidar com faces de menores dimensões. Faça Clique Direito nos cubos afetados e mude o \"Modo UV\" para \"UV por face\".",
	"dialog.plugins.outdated_client": "Requer uma versão mais recente do Blockbench",
	"dialog.plugins.outdated_plugin": "O plugin está desatualizado e não funciona com essa versão do Blockbench",
	"settings.motion_trails": "Trilhas de movimento",
	"settings.motion_trails.desc": "Mostrar trilhas de movimento no editor de animações.",
	"settings.antialiasing": "Suavização",
	"settings.antialiasing.desc": "Ative a suavização na pré-visualização. Reinicie o Blockbench para aplicar as mudanças.",
	"action.timeline_frame_back": "Voltar 1 segundo",
	"action.timeline_frame_forth": "Avançar 1 segundo",
	"panel.bone.ik": "Cinemática reversa (experimental)",
	"settings.particle_tick_rate": "Taxa de tique da partícula",
	"settings.particle_tick_rate.desc": "Taxa de tiques para os efeitos da partícula em tiques por segundo. O valor padrão é 30.",
	"action.lock_motion_trail": "Bloquear trilha de movimento",
	"action.lock_motion_trail.desc": "Bloqueia a trilha de movimento para o grupo selecionado.",
	"menu.animation_file.unload": "Descarregar arquivo de animação",
	"data.null_object": "Objeto vazio",
	"status_bar.toggle_sidebar": "Ativar barra lateral",
	"message.load_plugin_failed.title": "Falha ao carregar plugin",
	"message.load_plugin_failed.message": "Garanta que o nome do arquivo base desse plugin corresponde ao ID '%0' do plugin, como especificado em Plugin.register().",
	"dialog.project.uv_mode": "Modo UV",
	"dialog.project.uv_mode.box_uv": "Cubo UV",
	"dialog.project.uv_mode.face_uv": "UV por face",
	"dialog.project.texture_size": "Tamanho da textura",
	"dialog.animation_export.title": "Selecionar animações para exportar",
	"dialog.create_texture.rearrange_uv": "Organizar UV",
	"layout.color.subtle_text": "Texto sutil",
	"layout.color.subtle_text.desc": "Cor secundária do texto com menos contraste.",
	"settings.interface_scale": "Escala da interface",
	"settings.interface_scale.desc": "Escala de toda a interface do Blockbench.",
	"settings.background_rendering": "Renderizar plano de fundo",
	"settings.background_rendering.desc": "Atualiza a pré-visualização enquanto a janela não está em foco.",
	"settings.ctrl_shift_size": "Resolução Ctrl + Shift",
	"settings.ctrl_shift_size.desc": "Resolução da grade enquanto segura Ctrl e Shift.",
	"settings.hardware_acceleration": "Aceleração de hardware",
	"settings.hardware_acceleration.desc": "Permite que a placa gráfica execute as tarefas de renderização.",
	"action.explode_skin_model": "Aumentar modelo de skin",
	"action.explode_skin_model.desc": "Alterna uma vista explosiva que permite editar faces cobertas.",
	"action.export_minecraft_skin": "Exportar skin do minecraft",
	"action.export_minecraft_skin.desc": "Exportar skin do Minecraft como uma textura PNG",
	"action.add_null_object": "Adicionar objeto vazio",
	"action.add_null_object.desc": "Adiciona um novo objeto nulo.",
	"action.animated_texture_frame": "Quadro de textura animada",
	"action.animated_texture_frame.desc": "Define o quadro atual da textura animada.",
	"action.export_animation_file": "Exportar animações...",
	"action.export_animation_file.desc": "Exportar uma seleção de animações em um novo arquivo.",
	"action.timeline_graph_editor": "Ativar editor de grafos",
	"action.timeline_graph_editor.desc": "Ativa a linha do tempo entre o editor de grafos e o editor de chaves",
	"menu.file.recent.clear": "Limpar arquivos recentes",
	"switches.shade": "Sombra",
	"generic.share": "Compartilhar",
	"dates.minute": "%0 minuto",
	"dates.minutes": "%0 minutos",
	"dates.hour": "%0 hora",
	"dates.hours": "%0 horas",
	"dates.day": "%0 dia",
	"dates.days": "%0 dias",
	"dates.week": "%0 semana",
	"dates.weeks": "%0 semanas",
	"dates.year": "%0 ano",
	"dates.years": "%0 anos",
	"message.installed_plugin": "Plugin %0 instalado",
	"message.installed_plugin_fail": "Falha ao instalar o plugin %0",
	"dialog.share_model.title": "Compartilhar modelo",
	"dialog.share_model.expire_time": "Tempo expirado",
	"dialog.share_model.failed": "Falha em atualizar o modelo",
	"action.import_java_block_model": "Adicionar bloco java ou modelo de item",
	"action.import_java_block_model.desc": "Adiciona um bloco java ou modelo de item de um arquivo .json para o modelo atual.",
	"action.share_model": "Compartilhar...",
	"action.share_model.desc": "Gerar um link curto para compartilhar seu modelo",
	"action.import_project": "Importar projeto",
	"action.import_project.desc": "Importa outro projeto de um arquivo .bbmodel para o projeto atual.",
	"dialog.toolbar_edit.hidden_tools": "Algumas ferramentas podem estar escondidas porque elas não estão disponíveis no modelo, formato ou situação atual.",
	"settings.camera_near_plane": "Câmera próximo ao plano",
	"settings.camera_near_plane.desc": "A distância mínima da câmera onde os objetos renderizam. Valores maiores diminuem o Z-fighting. O valor padrão é 1.",
	"mode.start.keymap_preference.desc": "Se é novo no Blockbench e vem de outro programa 3D, pode selecionar um mapa de teclas para facilitar a transição. É possível alterar o mapa de teclas ou as atribuições de teclas individuais em outro momento nas configurações.",
	"message.load_keymap": "Deseja mesmo carregar esses atalhos? Isso irá substituir seus atalhos atuais.",
	"message.keymap_loaded": "Atalhos carregados",
	"dialog.convert_project.current_format": "Formato atual",
	"dialog.create_texture.rearrange_uv.desc": "Cria um novo arranjo UV para dar a cada face o seu próprio espaço na textura.",
	"dialog.create_texture.power.desc": "Prender o tamanho da textura automática para uma potência de 2, como 64 ou 128. Isso é necessário para alguns renderizadores.",
	"dialog.create_texture.double_use.desc": "Se dois elementos já tem o mesmo espaço UV correspondente, mantenha assim no novo mapa",
	"dialog.create_texture.padding.desc": "Adicione uma pequena pintura entre as partes individuais do modelo.",
	"dialog.create_texture.resolution.desc": "A resolução base da textura, em pixels por metro. O tamanho real do mapa de textura pode diferir dependendo da quantidade e tamanho dos elementos.",
	"dialog.create_gif.color": "Cor de fundo",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variante",
	"dialog.flip_animation.info": "Ossos opostos têm identificadores escritos como 'esquerdo' e 'direito' em seu nome.",
	"dialog.export_private_settings.title": "Opções privadas",
	"dialog.export_private_settings.message": "Seu arquivo tem as seguintes informações privadas: **%0**. Remova esses valores se planeja compartilhar o arquivo com outra pessoa.",
	"dialog.export_private_settings.keep": "Manter",
	"settings.timecode_frame_number": "Mostrar códigos de tempo como número do quadro",
	"settings.timecode_frame_number.desc": "Mostrar fração de códigos de tempo na linha do tempo como o número do quadro ao invés de centissegundo",
	"settings.animation_sample_rate": "Taxa de amostra da animação",
	"settings.animation_sample_rate.desc": "Taxa de amostra em amostras por segundo para curvas que o respectivo formato não suporta nativamente",
	"keybind.preview_zoom": "Zoom no campo visual",
	"action.gradient_tool": "Ferramenta gradiente",
	"action.gradient_tool.desc": "Cria uma cor gradiente na sua textura.",
	"action.import_settings": "Importar configurações",
	"action.import_settings.desc": "Importar arquivo .bbsettings",
	"action.export_settings": "Exportar configurações",
	"action.export_settings.desc": "Exporta as configurações do Blockbench como um arquivo .bbsettings",
	"action.load_keymap": "Carregar mapa de atalhos",
	"action.load_keymap.default": "Padrão (Trackpad)",
	"action.load_keymap.mouse": "Padrão (Mouse)",
	"action.load_keymap.default.desc": "Atribuições de teclas padrões do Blockbench, com controles de navegação da área de trabalho otimizados para uso em trackpads de laptops.",
	"action.load_keymap.mouse.desc": "Atribuições de teclas padrões do Blockbench, com a navegação da área de trabalho vinculada ao botão do meio do mouse.",
	"action.load_keymap.blender.desc": "Mapa de teclas para usuários familiarizados com os controles do Blender",
	"action.load_keymap.cinema4d.desc": "Mapa de teclas para usuários familiarizados com os controles do Cinema 4D",
	"action.load_keymap.maya.desc": "Mapa de teclas para usuários familiarizados com os controles do Autodesk Maya",
	"action.import_keymap": "Importar atalhos",
	"action.import_keymap.desc": "Importar atalhos de um arquivo .bbkeymap",
	"action.export_keymap": "Exportar mapa de atalhos",
	"action.export_keymap.desc": "Exportar mapa de atalhos como um arquivo .bbkeymap",
	"action.edit_history": "Editar histórico",
	"action.edit_history.desc": "Ver o histórico de edição e voltar/refazer etapas",
	"action.group_elements": "Elementos de grupo",
	"action.group_elements.desc": "Coloca os elementos selecionados em um novo grupo.",
	"action.unfold_groups": "Desdobrar grupos",
	"action.unfold_groups.desc": "Separa todos os grupos.",
	"action.edit_bedrock_binding": "Editando atalho...",
	"action.edit_bedrock_binding.desc": "Define a qual osso a geometria deve ser vinculada.",
	"action.pick_screen_color": "Selecionar cor da tela",
	"action.pick_screen_color.desc": "Seleciona uma cor em qualquer lugar da sua tela.",
	"action.view_mode": "Modo campo visual",
	"action.view_mode.desc": "Muda o campo visual do modelo.",
	"action.view_mode.textured": "Texturizado",
	"action.view_mode.solid": "Sólido",
	"action.view_mode.wireframe": "Aramado",
	"action.toggle_sidebars": "Ativar barras laterais",
	"action.toggle_sidebars.desc": "Ativa ou desativa as barras laterais.",
	"action.set_animation_end": "Configurar fim da animação",
	"action.set_animation_end.desc": "Configura o fim da animação selecionada para o tempo selecionado na linha do tempo.",
	"action.flip_animation": "Girar animação",
	"action.flip_animation.desc": "Gira partes da animação copiando os quadros selecionados para o outro lado do modelo.",
	"action.graph_editor_zero_line": "Incluir linha zero",
	"action.graph_editor_zero_line.desc": "Se o editor de gráficos sempre inclui a linha zero na visualização.",
	"menu.texture.render_mode": "Modo renderização",
	"menu.texture.render_mode.emissive": "Emissivo",
	"menu.texture.render_mode.layered": "Camadas",
	"menu.preview.angle.edit": "Editar ângulo...",
	"menu.animation.start_delay": "Começar atraso",
	"menu.animation.loop_delay": "Atraso em loop",
	"menu.animation.flip_keyframes": "Girar chaves de quadro",
	"menu.mobile_keyboard.disable_all": "Desabilitar tudo",
	"panel.keyframe.toggle_uniform_scale": "Ativar escala uniforme",
	"camera_angle.common_isometric_right": "Direita isométrica (2:1)",
	"camera_angle.common_isometric_left": "Esquerda isométrica (2:1)",
	"camera_angle.true_isometric_right": "Ativar direita isométrica (30°)",
	"camera_angle.true_isometric_left": "Ativar esquerda isométrica (30°)",
	"menu.help.wiki": "Wiki do Blockbench",
	"settings.update_to_prereleases": "Atualizar para pré-lançamentos",
	"settings.update_to_prereleases.desc": "Atualize automaticamente para versões beta do Blockbench para testar novos recursos. As versões de pré-lançamento podem ser instáveis. Deixe essa opção desativada se usa o Blockbench para trabalho ou outros projetos importantes.",
	"data.separator.spacer": "Espaçador",
	"data.separator.linebreak": "Quebra de linha",
	"data.setting": "Configuração",
	"generic.select_all": "Selecionar todos",
	"generic.select_none": "Selecionar nenhum",
	"projects.new_tab": "Nova aba",
	"projects.close_tab": "Fechar aba",
	"message.invalid_format.title": "Formato Inválido",
	"message.invalid_format.message": "Esse modelo foi feito no formato '%0' que está indisponível nesta instalação do Blockbench. Provavelmente, requer um plugin para abri-lo corretamente.",
	"message.invalid_link": "Link do modelo expirado ou inválido",
	"message.default_textures.current": "Caminho atual",
	"message.update_after_restart": "A atualização será instalada após reiniciar",
	"message.copy_paste_tool_viewport": "Essa ferramenta só pode ser utilizada no editor 2D",
	"dialog.project.shadow_size": "Tamanho da sombra",
	"dialog.find_replace.target": "Alvo",
	"dialog.find_replace.target.element_names": "Nomes dos elementos",
	"dialog.find_replace.target.group_names": "Nomes dos grupos",
	"dialog.find_replace.target.animation_names": "Nomes das animações",
	"dialog.find_replace.target.keyframe_values": "Valores de quadro",
	"dialog.find_replace.find": "Encontrar",
	"dialog.find_replace.replace": "Substituir",
	"dialog.find_replace.regex": "Expressão regular",
	"dialog.add_primitive.shape": "Forma",
	"dialog.add_primitive.shape.circle": "Círculo",
	"dialog.add_primitive.shape.tube": "Tubo",
	"dialog.add_primitive.shape.cone": "Cone",
	"dialog.add_primitive.shape.cylinder": "Cilindro",
	"dialog.add_primitive.shape.sphere": "Esfera",
	"dialog.add_primitive.shape.torus": "Toro",
	"dialog.add_primitive.shape.cube": "Cubo",
	"dialog.add_primitive.shape.pyramid": "Pirâmide",
	"dialog.add_primitive.diameter": "Diâmetro",
	"dialog.add_primitive.height": "Altura",
	"dialog.add_primitive.sides": "Lados",
	"dialog.add_primitive.minor_diameter": "Espessura",
	"dialog.add_primitive.minor_sides": "Lados menores",
	"dialog.create_texture.combine_polys": "Combinar ilhas",
	"dialog.create_texture.combine_polys.desc": "Combina faces em ilhas UV conectadas.",
	"dialog.model_stats.meshes": "Malha",
	"dialog.export_private_settings.omit": "Apagar",
	"layout.select": "Selecionar",
	"layout.options": "Opções",
	"layout.color": "Esquema de cores",
	"layout.documentation": "Documentação",
	"layout.color.bright_ui_text": "Texto de IU claro",
	"layout.color.bright_ui_text.desc": "Texto em fundos claros.",
	"layout.name": "Nome",
	"layout.author": "Autor",
	"settings.dialog.desc": "Mostrar o diálogo de \"%0\"",
	"settings.export_empty_groups": "Exportar grupos vazios",
	"settings.export_empty_groups.desc": "Inclui os grupos sem conteúdo nos arquivos exportados.",
	"category.separators": "Separadores",
	"keybind.preview_area_select": "Seleção por area",
	"action.color_erase_mode": "Modo apagar",
	"action.color_erase_mode.desc": "Ao ativar, ferramentas como preencher e retângulo subtraem cores, ao invés de as adicionar.",
	"action.open_from_link": "Abrir modelo de um link...",
	"action.open_from_link.desc": "Abrir um modelo de um URL blckbn.ch",
	"action.import_obj": "Importar modelo OBJ",
	"action.import_obj.desc": "Importa os objetos de um modelo OBJ como uma malha.",
	"action.add_plugin": "Instalar plugin",
	"action.add_plugin.desc": "Instalar um plugin pelo controle de ações.",
	"action.remove_plugin": "Desinstalar plugin",
	"action.remove_plugin.desc": "Desinstala um plugin pelo controle de ações.",
	"action.add_mesh": "Adicionar malha",
	"action.add_mesh.desc": "Adiciona uma nova malha.",
	"action.add_texture_mesh": "Adicionar nova malha texturizada",
	"action.add_texture_mesh.desc": "Adiciona uma nova malha de textura.",
	"action.find_replace": "Encontrar/Substituir...",
	"action.find_replace.desc": "Encontra e substitui partes de nomes ou valores",
	"action.hide_everything_except_selection": "Ocultar tudo menos a seleção",
	"action.hide_everything_except_selection.desc": "Alterna a visibilidade de todos os elementos, exceto os selecionados.",
	"action.transform_space.normal": "Normal",
	"action.selection_mode": "Modo seleção",
	"action.selection_mode.desc": "Muda como elementos podem ser selecionados na área de visualização.",
	"action.selection_mode.object": "Objeto",
	"action.selection_mode.face": "Face",
	"action.selection_mode.vertex": "Vértice",
	"action.create_face": "Criar face ou aresta",
	"action.create_face.desc": "Cria uma nova face ou aresta entre os vértices selecionados.",
	"action.convert_to_mesh": "Converter para malha",
	"action.convert_to_mesh.desc": "Converter os elementos selecionados para malhas.",
	"action.invert_face": "Inverter face",
	"action.invert_face.desc": "Inverte as faces selecionadas fazendo com que elas apontam na direção oposta",
	"action.extrude_mesh_selection": "Extrudir seleção",
	"action.extrude_mesh_selection.desc": "Extrude as partes selecionadas da malha.",
	"action.loop_cut": "Corte em loop",
	"action.loop_cut.desc": "Divide a malha em um loop através da aresta selecionada.",
	"action.merge_meshes": "Juntar malhas",
	"action.merge_meshes.desc": "Junta várias malhas em uma.",
	"action.keyframe_uniform": "Dilatação uniforme",
	"action.keyframe_uniform.desc": "Liga a dilatação uniforme nos quadros selecionados.",
	"menu.locator.ignore_inherited_scale": "Ignorar dilatação herdada",
	"menu.texture.elements": "Aplicar aos elementos",
	"uv_editor.transparent_face": "Face transparente",
	"display.pose_angle": "Ângulo de pose (só para pré-estreia)",
	"data.mesh": "Malha",
	"dialog.create_texture.type": "Tipo",
	"dialog.create_texture.type.blank": "Vazio",
	"dialog.create_texture.type.template": "Modelo de textura",
	"dialog.create_texture.type.color_map": "Modelo de cor sólida",
	"dialog.sketchfab_uploader.suggested_tags": "Marcadores sugeridos",
	"dialog.sketchfab_uploader.category": "Categoria",
	"dialog.sketchfab_uploader.category2": "Categoria 2",
	"layout.restore_backup": "Seu tema personalizado \"%0\" foi substituído. Clique para repô-lo.",
	"layout.borders": "Bordas",
	"action.fill_mode.element": "Elemento",
	"action.inset_mesh_selection": "Inverter seleção",
	"action.inset_mesh_selection.desc": "Inverte as partes selecionadas da malha.",
	"action.dissolve_edges": "Dissolver arestas",
	"action.dissolve_edges.desc": "Dissolve as arestas selecionadas em uma malha e junta as faces que dividiam.",
	"action.split_mesh": "Dividir malha",
	"action.split_mesh.desc": "Divide as faces selecionadas da malha para uma nova.",
	"action.merge_vertices": "Juntar vértices",
	"action.merge_vertices.desc": "Junta os vértices selecionados para a posição do vértice que foi selecionado primeiro.",
	"action.view_mode.normal": "Orientação da face",
	"action.snap_uv_to_pixels": "Forçar UV para píxels",
	"action.snap_uv_to_pixels.desc": "Força os vértices de UV selecionados para a gralha de píxeis",
	"menu.file.import.import_open_project": "Importar projeto aberto",
	"menu.help.unlock_projects": "Desbloquear todos os projetos",
	"status_bar.selection.faces": "%0 faces",
	"status_bar.selection.vertices": "%0 vértices",
	"message.merged_vertices": "%0 vértices encontrados em %1 posições",
	"settings.vertex_merge_distance": "Distância de ajuntamento",
	"settings.vertex_merge_distance.desc": "Define a distância limite para mesclar vértices automaticamente.",
	"settings.show_only_selected_uv": "Só mostrar UV selecionado",
	"settings.show_only_selected_uv.desc": "Só mostra as faces UV selecionadas no editor UV por padrão.",
	"action.merge_vertices.merge_all": "Juntar todos os vértices",
	"action.merge_vertices.merge_all_in_center": "Juntar todos os vértices no centro",
	"action.merge_vertices.merge_by_distance": "Juntar os vértices por distância",
	"action.merge_vertices.merge_by_distance_in_center": "Juntar por distância no centro",
	"action.uv_rotate_left": "Girar UV para a esquerda",
	"action.uv_rotate_left.desc": "Gira as faces UV selecionadas no sentido anti-horário.",
	"action.uv_rotate_right": "Rodar UV para a direita",
	"action.uv_rotate_right.desc": "Roda as faces de UV selecionadas no sentido horário.",
	"menu.uv.display_uv": "Mostrar UV",
	"menu.uv.display_uv.selected_faces": "Faces selecionadas",
	"menu.uv.display_uv.selected_elements": "Todas as faces",
	"menu.uv.display_uv.all_elements": "Todas as faces de todos os elementos",
	"menu.paste.face": "Face UV",
	"menu.paste.mesh_selection": "Seleção de malha",
	"menu.paste.outliner": "Elementos",
	"uv_editor.show_all_faces": "Mostrar todas as faces",
	"uv_editor.show_selected_faces": "Mostrar as faces selecionadas",
	"status_bar.selection.edges": "%0 arestas",
	"action.selection_mode.edge": "Aresta",
	"message.cannot_re_import.title": "Modelo não pode ser reimportado",
	"message.cannot_re_import.message": "O modelo exportado não pode ser importado novamente no Blockbench. Salve o seu modelo como um arquivo de projeto.",
	"generic.default": "padrão",
	"units.pixels_per_meter": "%0 píxeis por metro",
	"mode.pose": "Pose",
	"modifier_actions.resize_both_sides": "Dilatar em ambas as direções",
	"modifier_actions.resize_one_side": "Redimensionar em uma direção",
	"modifier_actions.draw_line": "Desenhar linha",
	"modifier_actions.drag_without_snapping": "Arrastar sem encaixar",
	"modifier_actions.stretch_keyframes": "Esticar quadros",
	"modifier_actions.resize_background": "Redimensionar plano de fundo",
	"modifier_actions.select_multiple": "\nSelecionar múltiplos",
	"modifier_actions.select_range": "Selecionar intervalo",
	"modifier_actions.drag_to_duplicate": "Arraste para duplicar",
	"modifier_actions.uniform_scaling": "Escala uniforme",
	"modifier_actions.snap_direction": "Direção de ajuste",
	"message.no_valid_elements": "Sem elementos selecionados",
	"dialog.add_primitive.shape.plane": "Plano",
	"dialog.save_angle.rotation_mode": "Modo rotação",
	"dialog.save_angle.rotation": "Rotação",
	"dialog.save_angle.fov": "Campo visual",
	"settings.hide_tab_bar": "Esconder automaticamente a barra da aba",
	"settings.hide_tab_bar.desc": "Esconde a barra da aba quando só uma aba estiver aberta.",
	"settings.status_bar_modifier_keys": "Sugerir teclas de modificador na barra de status",
	"settings.status_bar_modifier_keys.desc": "Mostrar teclas de modificador sugeridas baseadas no contexto na barra da aba",
	"settings.ground_plane": "Chão",
	"settings.ground_plane.desc": "Mostra um chão embaixo do modelo",
	"settings.preview_paste_behavior": "Comportamento de colagem de visualização padrão",
	"settings.preview_paste_behavior.desc": "Seleciona o comportamento ao colar algo na área de visualização.",
	"settings.preview_paste_behavior.always_ask": "Perguntar sempre",
	"action.new_window": "Nova aba",
	"action.new_window.desc": "Abre uma nova aba no Blockbench.",
	"action.export_collada": "Exportar modelo collada (dae)",
	"action.export_collada.desc": "Exporta um modelo collada (dae) para usar em outras aplicações.",
	"action.paint_mode_uv_overlay": "Sobreposição UV",
	"action.paint_mode_uv_overlay.desc": "Mostra o mapa UV sobreposto no modo pintura.",
	"action.bake_animation_into_model": "Aplicar animação no modelo",
	"action.bake_animation_into_model.desc": "Aplica o quadro da animação mostrada no modelo. Aplica-se apenas a rotação e a posição. A dilatação é ignorada.",
	"action.keyframe_interpolation.step": "Passo",
	"action.set_ik_target": "Definir alvo CI",
	"action.set_ik_target.desc": "Seleciona o osso-alvo que deve ser movido por esse objeto nulo por cinemática inversa.",
	"menu.action_control.type.tab": "Aba",
	"menu.action_control.type.angle": "Ângulo de câmera",
	"menu.action_control.recent_in_streamer_mode": "Deseja continuar? O modo transmissão está ligado",
	"menu.action_control.recent_in_streamer_mode.desc": "Deseja mesmo mostrar os modelos recentes?",
	"menu.tools": "Ferramentas",
	"menu.file.recent.more": "Ver mais",
	"menu.null_object.lock_ik_target_rotation": "Bloquear a rotação do alvo IK",
	"menu.animation_file.import_remaining": "Importar animações restantes do arquivo",
	"edit.loop_cut.offset": "Desvio",
	"edit.extrude_mesh_selection.extend": "Estendido",
	"cube.color.pink": "Rosa",
	"cube.color.silver": "Prata",
	"dialog.plugins.offline": "Sem conexão com a internet",
	"dialog.create_texture.pixel_density": "Densidade de píxeis",
	"dialog.create_texture.pixel_density.desc": "A densidade de píxeis da textura, em píxeis por metro. O tamanho do mapa de textura pode diferir dependendo da quantidade e tamanho dos elementos.",
	"panel.skin_pose": "Pose",
	"panel.skin_pose.none": "Neutro",
	"panel.skin_pose.natural": "Natural",
	"panel.skin_pose.walking": "Andando",
	"panel.skin_pose.crouching": "Agachado",
	"panel.skin_pose.sitting": "Sentado",
	"panel.skin_pose.jumping": "Pulando",
	"panel.skin_pose.aiming": "Apontando",
	"edit.loop_cut.direction": "Direção",
	"data.texture_mesh": "Malha de textura",
	"generic.left": "Esquerda",
	"generic.right": "Direita",
	"mode.start.quick_setup": "Configuração rápida",
	"mode.start.keymap": "Mapa-chave",
	"mode.start.quick_setup.more_themes": "Mais...",
	"dialog.resize_texture.animation_frames": "Quadros de animação",
	"dialog.export_emission_map.title": "Exportar mapa de emissão",
	"dialog.export_emission_map.format": "Formato",
	"dialog.export_emission_map.format.luminance": "Luminância",
	"dialog.export_emission_map.format.luminance_inverted": "Luminância invertida",
	"dialog.export_emission_map.format.colors": "Cores",
	"dialog.export_emission_map.threshold": "Limiar de transparência",
	"dialog.export_emission_map.round_up": "Arredondar para cima para %0 × %1",
	"dialog.export_emission_map.flip_y": "Inverter eixo Y",
	"dialog.select.type": "Tipo de elemento",
	"dialog.create_texture.max_edge_angle": "Limiar de ângulo da aresta",
	"dialog.create_texture.max_edge_angle.desc": "Define o limite angular para a combinação de faces adjacentes.",
	"dialog.create_texture.max_island_angle": "Limiar de ângulo da ilha",
	"dialog.create_texture.max_island_angle.desc": "O ângulo máximo que pode ser combinado na mesma ilha UV.",
	"settings.mobile_panel_side": "Lado do painel móvel",
	"settings.mobile_panel_side.desc": "Seleciona em qual lado da tela os painéis são mostrados ao usar o Blockbench no modo paisagem.",
	"settings.obj_face_export_mode": "Modo de exportação de face OBJ",
	"settings.obj_face_export_mode.desc": "Escolha se o exportador OBJ deve converter todas as faces em triângulos ou quadriláteros.",
	"settings.obj_face_export_mode.both": "Padrão",
	"settings.obj_face_export_mode.tris": "Converter para triângulos",
	"settings.obj_face_export_mode.quads": "Converter para quadriláteros",
	"action.seam_tool": "Ferramenta de costura",
	"action.seam_tool.desc": "Define costuras UV em arestas de malha.",
	"action.resolve_group": "Resolver grupo",
	"action.resolve_group.desc": "Resolve o grupo mantendo seus derivantes no mesmo lugar.",
	"action.move_to_group": "Mover para",
	"action.move_to_group.desc": "Mova os elementos selecionados para um grupo ou elemento diferente na lista hierárquica.",
	"action.select_seam": "Selecionar costura UV",
	"action.select_seam.desc": "Seleciona o modo costura UV para as arestas selecionadas.",
	"action.select_seam.auto": "Auto.",
	"action.select_seam.join": "Entrar",
	"action.select_seam.divide": "Dividir",
	"action.adjust_brightness_contrast": "Ajustar brilho e contraste...",
	"action.adjust_brightness_contrast.desc": "Ajusta o brilho e o contraste da textura selecionada.",
	"action.adjust_saturation_hue": "Ajustar saturação e matiz...",
	"action.adjust_saturation_hue.desc": "Ajusta a saturação e o matiz da textura selecionada.",
	"action.invert_colors": "Inverter cores",
	"action.invert_colors.desc": "Inverte todas as cores da textura selecionada.",
	"action.adjust_curves": "Ajustar curvas...",
	"action.adjust_curves.desc": "Ajusta o brilho das curvas da textura selecionada.",
	"action.flip_texture_x": "Inverter horizontalmente",
	"action.flip_texture_y": "Inverter verticalmente",
	"action.resize_texture": "Redimensionar textura...",
	"action.view_mode.uv": "Pré-visualização UV",
	"action.append_to_template": "Adicionar elementos ao modelo...",
	"action.append_to_template.desc": "Adiciona ao modelo de textura os elementos que estão selecionados",
	"action.move_texture_with_uv": "Mover textura com UV",
	"action.move_texture_with_uv.desc": "Mova a textura da face ao arrastar faces UV",
	"action.timeline_setups": "Configurações da linha do tempo",
	"action.save_timeline_setup": "Salvar configuração da linha do tempo...",
	"action.save_timeline_setup.desc": "Salva uma predefinição para as animações e os canais selecionados",
	"menu.texture": "Textura",
	"menu.texture.render_mode.default": "Padrão",
	"menu.texture.merge_onto_texture": "Mesclar na textura acima",
	"menu.animation.unload": "Descarregar",
	"panel.timeline": "Linha do tempo",
	"action.pan_tool": "Ferramenta panorâmica",
	"action.pan_tool.desc": "Navegue pela área de trabalho e no editor de texturas.",
	"mode.start.recent.favorite": "Marcar como favorito",
	"mode.start.info": "Outros",
	"mode.start.target": "Alvo",
	"mode.start.start": "Iniciar",
	"mode.start.create_new": "Criar novo modelo",
	"mode.start.format.informations": "Saiba que:",
	"mode.start.format.resources": "Recursos:",
	"format.free.info.meshes": "Nesse formato, você pode criar modelos com baixo números de polígonos usando cubos e malhas com formatos personalizados.",
	"format.free.info.limitation": "Os modelos não podem ser carregados em jogos que exigem formatos específicos, como o Minecraft.",
	"format.skin.info.skin": "Esse formato foi desenvolvido para criar skins e texturas de entidades para Minecraft.",
	"format.skin.info.model": "O modelo não pode ser alterado. Para fazer alterações nele, primeiro converta para um formato diferente por meio de: **Arquivo** > **Converter Projeto**.",
	"format.java_block.info.rotation": "As rotações são limitadas a um eixo por elemento",
	"format.java_block.info.size": "O modelo está limitado a um tamanho de 3x3x3 blocos. No entanto, as configurações de exibição podem tornar os modelos de itens maiores",
	"format.java_block.info.animation": "Esse formato não suporta animações no Minecraft vanilla. Se estiver criando um mod, você pode usar o GeckoLib para animar modelos. Caso contrário, a única forma de animar é alternar o modelo usando comandos ou texturas animadas.",
	"format.bedrock.info.textures": "Cada modelo pode ter apenas uma textura",
	"format.bedrock_block": "Bloco Bedrock",
	"format.bedrock_block.desc": "Modelo de bloco para Minecraft: Bedrock Edition",
	"format.modded_entity.info.integer_size": "O tamanho dos cubos individuais é limitado a números inteiros.",
	"format.modded_entity.info.format": "Os modelos são escritos em código Java em vez de estruturas de dados dedicadas como todos os outros formatos de exportação do Blockbench.",
	"format.optifine_entity.info.optifine_required": "O modelo não é visível para os usuários sem o OptiFine instalado.",
	"format.optifine_entity.info.pivots": "Os pivôs dos ossos estão travados, sendo recomendado mantê-los inalterados.",
	"format_category.low_poly": "Menos polígonos",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Outro",
	"format_category.loaders": "Carregadores",
	"message.recover_backup.recover": "Recuperar",
	"message.invalid_characters.title": "Caminho inválido",
	"message.invalid_characters.message": "O caminho do arquivo importado tem caracteres inválidos, letras maiúsculas ou espaços em branco. Os caracteres suportados são: %0",
	"dialog.share_model.thumbnail": "Miniatura",
	"dialog.skin.high_res_texture": "Observe que as skins com a resolução selecionada não funcionarão como skins normais do Minecraft. Selecione uma resolução menor.",
	"settings.allow_display_slot_mirror": "Permitir espelhamento do espaço de tela",
	"settings.allow_display_slot_mirror.desc": "Permite espelhar os espaços de exibição dos modelos de itens Java. AVISO: Isso só funciona no Minecraft 1.14 ou inferior, ou em casos especiais.",
	"action.switch_tabs": "Trocar abas",
	"action.switch_tabs.desc": "Alterna entre as abas abertas. Mantenha a tecla Shift pressionada para alternar na direção oposta.",
	"action.unselect_all": "Desmarcar tudo",
	"action.save_palette": "Salvar paleta...",
	"action.save_palette.desc": "Salva a paleta de cores atual no Blockbench para usar em outro momento",
	"action.keyframe_column_create": "Criar coluna de quadro-chave",
	"action.keyframe_column_create.desc": "Define os quadros-chave de todos os canais na linha do tempo no código de tempo atual, caso já tenham outros.",
	"action.keyframe_column_select": "Selecionar coluna de quadros-chave.",
	"action.keyframe_column_select.desc": "Seleciona todos os quadros-chave na linha do tempo ao longo de uma coluna abaixo da cabeça de reprodução.",
	"menu.uv": "UV",
	"menu.keyframe": "Quadro-chave",
	"menu.palette.load.update": "Atualizar paleta",
	"menu.palette.load.update.desc": "Atualiza essa paleta com as cores da atual do Blockbench.",
	"menu.timeline_marker.set_time": "Definir tempo...",
	"uv_editor.scale_uv": "Escala UV",
	"action.preview_scene": "Pré-visualizar cena",
	"action.preview_scene.desc": "Altera a cena de pré-visualização do modelo",
	"preview_scene.minecraft_overworld": "Superfície",
	"preview_scene.minecraft_nether": "Nether",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Inverter eixo Y",
	"preview_scene.studio": "Estúdio",
	"format.image": "Imagem",
	"modifier_actions.set_copy_source": "Definir copiar de origem",
	"message.load_images.title": "Carregar imagens",
	"message.load_images.edit_image": "Editar imagem",
	"dialog.add_primitive.align_edges": "Alinhar arestas",
	"dialog.flip_animation.show_in_timeline": "Mostrar ossos modificados na reta cronológica",
	"settings.default_cube_size": "Tamanho do cubo",
	"settings.default_cube_size.desc": "Define o tamanho padrão do cubo ao criar um novo.",
	"settings.uniform_keyframe": "Quadros-chave de escala uniforme",
	"settings.uniform_keyframe.desc": "Define os quadros-chave de escala para escala uniforme por padrão.",
	"settings.nearest_rectangle_select": "Seleção retangular: aresta mais próxima",
	"settings.nearest_rectangle_select.desc": "Ajusta as seleções retangulares para a aresta de píxel mais próxima, como no GIMP, em vez de píxeis inteiros.",
	"settings.pick_color_opacity": "Pegar opacidade da cor",
	"settings.pick_color_opacity.desc": "Pega a opacidade da cor com o seletor de cores e a define como opacidade do pincel",
	"settings.paint_with_stylus_only": "Pintar apenas com caneta",
	"settings.paint_with_stylus_only.desc": "Usar apenas a caneta para pintura, reservando o mouse ou toque para navegação.",
	"action.copy_brush_mode": "Modo pincel copiador",
	"action.copy_brush_mode.copy": "Copiar",
	"action.copy_brush_mode.pattern": "Padrão",
	"action.copy_brush_mode.sample": "Amostragem",
	"action.brush_shape": "Formato do pincel",
	"action.brush_shape.square": "Quadrado",
	"action.brush_shape.circle": "Círculo",
	"action.blend_mode": "Modo de mesclagem",
	"action.blend_mode.default": "Padrão",
	"action.blend_mode.set_opacity": "Definir opacidade",
	"action.blend_mode.color": "Cor",
	"action.blend_mode.behind": "Por trás",
	"action.blend_mode.multiply": "Multiplicar",
	"action.blend_mode.divide": "Dividir",
	"action.blend_mode.add": "Adicionar",
	"action.blend_mode.subtract": "Subtrair",
	"action.blend_mode.screen": "Tela",
	"action.blend_mode.overlay": "Sobreposição",
	"action.blend_mode.hard_light": "Luz sólida",
	"action.blend_mode.difference": "Diferença",
	"action.copy_brush": "Pincel copiador",
	"action.copy_brush.desc": "Um pincel que clona partes da sua textura ou desenhar padrões. Mantenha pressionada a tecla Ctrl e clique para selecionar uma fonte de cópia.",
	"action.validator_window": "Problemas do modelo de visualização...",
	"action.validator_window.desc": "Abre o validador que lista os problemas com o modelo atual.",
	"action.cancel_gif": "Cancelar GIF",
	"menu.text_edit.copy_vector": "Copiar vetor",
	"menu.brush_presets.dialog": "Pincéis predefinidos...",
	"menu.brush_presets.pixel_brush": "Pincel de píxel",
	"menu.brush_presets.smooth_brush": "Pincel suave",
	"menu.texture.edit_in_blockbench": "Editar no Blockbench",
	"menu.mirror_painting.axis": "Eixos",
	"menu.mirror_painting.axis.desc": "Seleciona em qual eixo os traços de pintura serão espelhados",
	"menu.mirror_painting.global": "Simetria global",
	"menu.mirror_painting.global.desc": "Ativa a pintura espelhada no modelo no espaço global.",
	"menu.mirror_painting.local": "Simetria local",
	"menu.mirror_painting.local.desc": "Ativa a pintura espelhada no espaço local para cada elemento.",
	"menu.mirror_painting.texture_frames": "Repetir em quadros de folioscópio",
	"menu.mirror_painting.texture_frames.desc": "Espelha traços de pintura para cada quadro de texturas animadas",
	"format.bedrock_block.info.size_limit": "O tamanho total de um bloco é limitado a 30 pixels em todas as dimensões. O limite pode estar descentralizado em todas as direções em 7 pixels a partir do centro do bloco.",
	"format.bedrock_block.info.textures": "Podem ser aplicadas várias texturas a diferentes cubos no Blockbench, mas exigem uma configuração adicional no pacote de comportamento para funcionar corretamente no jogo.",
	"format.image.desc": "Edita imagens no editor de imagem 2D",
	"generic.delete_all": "Apagar tudo",
	"message.child_model_only.open": "Abrir pai",
	"message.child_model_only.open_with_textures": "Abrir derivador e adotar texturas",
	"dialog.project.credit": "Crédito",
	"dialog.convert_project.create_copy": "Criar cópia",
	"dialog.texture.frame_time": "Tempo de quadro",
	"dialog.texture.frame_time.desc": "Define por quanto tempo cada quadro ficará visível, em tiques. Cada tique corresponde a 1/20 de segundo.",
	"dialog.texture.frame_interpolate": "Interpolar",
	"dialog.texture.frame_interpolate.desc": "Interpole entre os quadros da animação fazendo uma transição suave para o próximo quadro.",
	"dialog.texture.frame_order_type": "Modo loop",
	"dialog.texture.frame_order_type.loop": "Loop",
	"dialog.texture.frame_order_type.backwards": "Loop invertido",
	"dialog.texture.frame_order_type.back_and_forth": "Vai e volta",
	"dialog.texture.frame_order_type.custom": "Ordem personalizada",
	"dialog.texture.frame_order": "Ordem de quadros",
	"dialog.texture.frame_order.desc": "Define uma ordem de quadros personalizada listando os índices dos quadros em uma nova ordem. Os índices começam em 0 com o primeiro quadro.",
	"dialog.select.mode": "Modo",
	"dialog.select.mode.new": "Nova seleção",
	"dialog.select.mode.add": "Adicionar à seleção",
	"dialog.select.mode.remove": "Remover da seleção",
	"dialog.select.mode.in_selection": "Selecionar apenas do selecionado",
	"dialog.predicate_overrides.model": "Modelo",
	"dialog.predicate_overrides.predicates": "Predicados",
	"dialog.predicate_overrides.variants": "Variantes",
	"dialog.predicate_overrides.start_value": "Iniciar",
	"dialog.predicate_overrides.add_override": "Adicionar sobreposição",
	"dialog.predicate_overrides.add_predicate": "Adicionar predicado",
	"dialog.predicate_overrides.generate_overrides": "Gerenciar sobreposições",
	"dialog.predicate_overrides.confirm_delete": "Deseja mesmo apagar todas as sobreposições?",
	"dialog.predicate_overrides.predicate.angle": "Ângulo da bússola",
	"dialog.predicate_overrides.predicate.blocking": "Está bloqueando",
	"dialog.predicate_overrides.predicate.broken": "Está quebrado",
	"dialog.predicate_overrides.predicate.cast": "Está lançado",
	"dialog.predicate_overrides.predicate.cooldown": "Tempo de recarga",
	"dialog.predicate_overrides.predicate.damage": "Dano",
	"dialog.predicate_overrides.predicate.damaged": "Está danificado",
	"dialog.predicate_overrides.predicate.lefthanded": "É canhoto",
	"dialog.predicate_overrides.predicate.pull": "Quantidade de torque",
	"dialog.predicate_overrides.predicate.pulling": "Está puxando",
	"dialog.predicate_overrides.predicate.charged": "Está carregado",
	"dialog.predicate_overrides.predicate.firework": "Tem fogo de artifício",
	"dialog.predicate_overrides.predicate.throwing": "Pronto para lançar",
	"dialog.predicate_overrides.predicate.time": "Tempo do dia",
	"dialog.predicate_overrides.predicate.custom_model_data": "Dados do modelo personalizado",
	"dialog.predicate_overrides.predicate.level": "Nível da luz",
	"dialog.predicate_overrides.predicate.filled": "Bundle Fill Level",
	"dialog.predicate_overrides.predicate.tooting": "Tooting",
	"settings.model_export_scale": "Exportar escala do modelo",
	"settings.model_export_scale.desc": "O fator pelo qual a escala dos modelos glTF, DAE e FBX exportados é reduzida. O padrão é 16 que converte 16 unidades do Blockbench em 1 metro na exportação.",
	"action.export_fbx": "Exportar moldelo FBX",
	"action.export_fbx.desc": "Exporta o modelo e as animações como arquivo FBX para usá-lo em outros aplicativos 3D e motores de jogo.",
	"action.center_lateral": "Centralizar lateral",
	"action.center_lateral.desc": "Centralizar os elementos selecionados nos eixos X e Z",
	"action.adjust_opacity": "Ajustar opacidade...",
	"action.adjust_opacity.desc": "Ajusta a opacidade da textura selecionada",
	"action.rotate_texture_cw": "Girar no sentido horário",
	"action.rotate_texture_ccw": "Gire no sentido anti-horário.",
	"action.predicate_overrides": "Editar substituições de predicado...",
	"action.predicate_overrides.desc": "Selecione os modelos para substituir esse com base nas condições selecionadas.",
	"action.auto_set_cullfaces": "Definir filtros de face oculta automaticamente",
	"action.auto_set_cullfaces.desc": "Gera automaticamente faces ocultas para esconder as outras quando elas estiverem cobertas pelo bloco ao lado.",
	"menu.texture.edit_externally": "Editar externamente",
	"menu.mirror_painting.texture": "Simetria do editor 2D",
	"menu.mirror_painting.texture.desc": "Ativa a pintura espelhada em espaço 2D na imagem ou textura",
	"menu.animator.rotation_global": "Rotacionar no espaço global",
	"uv_editor.face_properties": "Propriedades da face",
	"uv_editor.face_properties.material_instance": "Instância de material",
	"uv_editor.tint.info": "A opção de matiz pode ser ativada em uma face para instruir o Minecraft a colorir essa face. No Minecraft vanilla, o matiz só pode ser usada por blocos específicos, como folhas e pó de redstone, e só pode ter o valor 0.",
	"uv_editor.cullface.info": "Ativar a 'face oculta' instrui uma face em um bloco a não ser renderizada se outro bloco completo seja colocado adjacente a ela na direção especificada no seu mundo do Minecraft. Isso pode ser usado para otimizar o desempenho.",
	"uv_editor.material_instance.info": "As instâncias de material podem ser definidas com um nome colocado pelo usuário. Esse nome pode ser usado no arquivo JSON do bloco, no pacote de comportamento, para atribuir uma textura e um material específico à face.",
	"display.reference.frame_invisible": "Moldura (invisível)",
	"data.settings_profile": "Perfil",
	"message.display_skin.invalid_name": "Não foi possível encontrar a conta do Minecraft com o nome '%0'",
	"dialog.load_plugins_from_query.title": "Carregar plugins",
	"dialog.load_plugins_from_query.text": "Você usou um link que requer a instalação de plugins. Deseja instalá-los?",
	"dialog.select_model.title": "Selecionar modelo",
	"dialog.select_model.bones": "Ossos",
	"dialog.select_model.cubes": "Cubos",
	"dialog.settings.create_profile": "Criar perfil...",
	"settings_profile.confirm_delete": "Deseja mesmo apagar essas configurações de perfil?",
	"settings_profile.condition.type.selectable": "Selecionável manualmente",
	"settings.interface_mode": "Modo UI",
	"settings.interface_mode.desc": "Modo interface",
	"settings.interface_mode.auto": "Automático",
	"settings.interface_mode.desktop": "Área de trabalho",
	"settings.interface_mode.mobile": "Celular",
	"settings.paint_through_transparency": "Pintar por transparência",
	"settings.paint_through_transparency.desc": "Pinte por píxeis transparentes quando o 'canal alfa bloqueado' estiver ativado",
	"action.tab_overview": "Visão geral da aba",
	"action.tab_overview.desc": "Veja todas as abas abertas em uma grade e acesse uma delas.",
	"action.slider_color_red": "Cor vermelha",
	"action.slider_color_green": "Cor verde",
	"action.slider_color_blue": "Color azul",
	"action.add_animation_controller": "Adicionar controlador de animação",
	"action.add_animation_controller.desc": "Cria um controlador de animação em branco",
	"action.animation_controller_preview_mode": "Pré-visualização do controlador",
	"action.animation_controller_preview_mode.paused": "Pausado",
	"action.animation_controller_preview_mode.manual": "Pré-visualização manual",
	"action.animation_controller_preview_mode.play": "Reprodução automática",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Curva de ligação de Bézier",
	"action.keyframe_bezier_linked.desc": "Conecta as curvas de Bézier aos quadros-chave direito e esquerdo.",
	"action.reset_keyframe_handles": "Redefinir curvas do quadro-chave",
	"action.reset_keyframe_handles.desc": "Redefine as curvas de Bézier dos quadros-chave selecionados.",
	"action.looped_animation_playback": "Reprodução em loop",
	"action.looped_animation_playback.desc": "Pré-visualização de animações em loop",
	"timeline.bind_to_actor": "Vincular ao ator",
	"animation_controllers.select_preset": "Selecione uma predefinição de controlador...",
	"animation_controllers.state.animations": "Animações",
	"animation_controllers.state.particles": "Partículas",
	"animation_controllers.state.sounds": "Sons",
	"animation_controllers.state.on_entry": "Na entrada",
	"animation_controllers.state.on_exit": "Na saída",
	"animation_controllers.state.transitions": "Transições",
	"animation_controllers.state.condition": "Condição",
	"animation_controllers.state.blend_transition": "Tempo de mesclagem",
	"animation_controllers.state.shortest_path": "Mesclar pelo caminho mais curto",
	"animation_controllers.state.edit_transition": "Editar transição",
	"menu.color_picker.picker_type": "Tipo de selecionador",
	"menu.color_picker.picker_type.square": "Quadrado",
	"menu.color_picker.picker_type.wheel": "Roda",
	"menu.color_picker.slider_mode": "Modo deslizante",
	"menu.color_picker.slider_mode.hsv": "Matiz, Saturação, Valor",
	"menu.color_picker.slider_mode.rgb": "Vermelho, Verde, Azul",
	"menu.texture.render_mode.additive": "Aditivo",
	"panel.color.picker_options": "Opções do seletor de cores",
	"panel.animation_controllers": "Controlador de animações",
	"display.preset.armor_stand": "Chão (Suporte de Armaduras)",
	"data.file_path": "Caminho do arquivo",
	"dialog.extrude.orientation": "Orientação",
	"dialog.extrude.orientation.upright": "Vertical",
	"dialog.extrude.orientation.flat": "Plano",
	"dialog.scale.box_uv_warning": "Redimensionar uma caixa de modelo UV pode corromper as coordenadas UV do seu modelo. Em vez disso, tente redimensionar o modelo externamente ou alterne para o modo UV por face em Arquivo > Projeto.",
	"dialog.create_gif.format": "Formato",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "Sequência PNG",
	"dialog.create_gif.pixelate": "Pixelar",
	"dialog.create_gif.bg_image": "Imagem do plano de fundo",
	"dialog.create_gif.turn.desc": "Gira o modelo enquanto grava. Use valores negativos para girar o modelo no sentido horário. Um valor de 60 corresponde a uma rotação por segundo.",
	"settings_profile.condition": "Condição",
	"settings_profile.condition.type.file_path.desc": "Use a sintaxe de expressão regular para encontrar o caminho do arquivo do projeto atual. Use barras (/) para diretórios.",
	"settings.only_selected_bezier_handles": "Mostrar apenas as curvas de Bézier selecionadas",
	"settings.only_selected_bezier_handles.desc": "Oculta as curvas de bézier nos quadros-chave que não estão selecionados",
	"settings.embed_textures": "Incorporar texturas",
	"settings.embed_textures.desc": "Incorpora o conteúdo do arquivo de textura nos arquivos .bbmodel",
	"action.selection_mode.cluster": "Conjunto",
	"dialog.copied_to_clipboard": "Copiado",
	"data.reference_image": "Imagem de referência",
	"message.delete_reference_image": "Deseja mesmo apagar essa imagem de referência? Isso não pode ser desfeito.",
	"message.add_reference_image.message": "Selecione onde carregar a imagem de referência",
	"message.add_reference_image.project": "Adicionar para esse projeto",
	"message.add_reference_image.app": "Adicionar para todos os projetos",
	"message.import_particle_texture.import": "Importar textura de partícula",
	"message.import_particle_texture.message": "Deseja importar um arquivo de textura para ser usado em sua partícula?",
	"message.save_codec_selector.title": "Salvar formato do modelo",
	"message.save_codec_selector.message": "Seleciona um formato para salvar o modelo.",
	"message.save_codec_selector.project_file": "Projeto Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "Ambos",
	"message.display_skin.username": "Nome de usuário (Java)",
	"message.palette_locked": "Paleta bloqueada",
	"dialog.project.default_uv_mode": "Modo UV padrão",
	"dialog.project.default_uv_mode.description": "Modo UV padrão do projeto. O esse modo também pode ser alterado por cubo.",
	"dialog.export_options.title": "Opções de exportação",
	"dialog.edit_texture.preview": "Pré-visualização",
	"dialog.proportional_editing.range": "Alcance",
	"dialog.proportional_editing.falloff": "Decaimento",
	"dialog.proportional_editing.falloff.linear": "Linear",
	"dialog.proportional_editing.falloff.hermite_spline": "Suave",
	"dialog.proportional_editing.falloff.constant": "Constante",
	"dialog.proportional_editing.selection": "Seleção",
	"dialog.proportional_editing.selection.linear": "Distância linear",
	"dialog.proportional_editing.selection.connections": "Conexões",
	"dialog.mirror_painting_texture_center.middle": "Meio",
	"dialog.mirror_painting_texture_center.custom": "Personalizada",
	"dialog.settings.reset_to_default": "Redefinir para o padrão",
	"keybindings.item.num_slider.increase": "Aumentar",
	"keybindings.item.num_slider.decrease": "Diminuir",
	"settings.always_show_splash_art": "Sempre mostrar tela de abertura",
	"settings.always_show_splash_art.desc": "Sempre mostra a imagem de abertura na tela inicial",
	"action.slider_palette_color": "Mudar cor da paleta",
	"action.slider_palette_color.desc": "Alterna entre as cores da paleta",
	"action.proportional_editing": "Edição proporcional",
	"action.proportional_editing.desc": "Afetar proporcionalmente os vértices circundantes ao editar partes de uma malha.",
	"action.limit_to_palette": "Limitar paleta",
	"action.limit_to_palette.desc": "Limita as cores da textura àquelas carregadas na paleta.",
	"action.edit_reference_images": "Editar imagens de referência",
	"action.edit_reference_images.desc": "Ativar o modo de imagem de referência para adicionar ou editar imagens de referência e projeto",
	"action.add_reference_image": "Adicionar imagem de referência",
	"action.reference_image_from_clipboard": "Copiar imagem de referência",
	"action.reference_image_list": "Imagens de referência",
	"action.connect_uv_faces": "Conectar faces UV",
	"action.connect_uv_faces.desc": "Conecta as faces UV selecionadas na última selecionada.",
	"action.merge_uv_vertices": "Mesclar vértices UV",
	"action.merge_uv_vertices.desc": "Ajusta os primeiros vértices UV selecionados aos últimos selecionados",
	"action.bedrock_animation_mode": "Modo de animação bedrock",
	"action.bedrock_animation_mode.desc": "Seleciona o modo para editar animações do Minecraft: Bedrock Edition",
	"action.bedrock_animation_mode.entity": "Entidade",
	"action.bedrock_animation_mode.attachable_first": "Item em 1ª pessoa",
	"action.bedrock_animation_mode.attachable_third": "Item em 3ª pessoa",
	"timeline.amplify": "Amplificar",
	"menu.options": "Opções...",
	"menu.palette.lock_palette": "Bloquear paleta",
	"menu.uv.export": "Exportar mapeamento UV",
	"menu.uv.flip_x": "Espelhar eixo X",
	"menu.uv.flip_y": "Espelhar eixo Y",
	"menu.mirror_painting.enabled": "Ativado",
	"reference_image.position": "Posição",
	"reference_image.size": "Tamanho",
	"reference_image.rotation": "Rotação",
	"reference_image.opacity": "Opacidade",
	"reference_image.visibility": "Visibilidade",
	"reference_image.clear_mode": "Modo limpeza",
	"reference_image.layer": "Camada",
	"reference_image.layer.background": "Atrás do modelo",
	"reference_image.layer.viewport": "Acima do modelo",
	"reference_image.layer.float": "Acima da interface",
	"reference_image.scope": "Escopo",
	"reference_image.scope.project": "Apenas esse projeto",
	"reference_image.scope.global": "Todos os projetos",
	"reference_image.enabled_modes": "Ativado em modos",
	"codec.common.encoding": "Codificando",
	"codec.common.armature": "Exportar grupos como armadura",
	"codec.common.export_animations": "Exportar animações",
	"codec.common.embed_textures": "Incorporar texturas",
	"preview.center_camera": "Centralizar câmera",
	"display.reference.frame_top": "Topo da moldura",
	"display.reference.frame_top_invisible": "Topo da moldura (invisível)",
	"action.proportional_editing_range": "Alcance da edição proporcional ",
	"action.proportional_editing_range.desc": "Ajusta o alcance para a edição proporcional.",
	"action.toggle_all_reference_images": "Ocultar/Mostrar todas as imagens de referência",
	"action.toggle_all_reference_images.desc": "Alterna a visibilidade de todas as imagens de referência de uma vez.",
	"action.add_animation_controller_state": "Adicionar estado do controlador de animação",
	"action.add_animation_controller_state.desc": "Adicionar um novo estado ao controlador de animação.",
	"menu.slider.round_value": "Arredondar valor",
	"texture.error.too_large": "A resolução excede o máximo de %0",
	"dialog.copy_to_clipboard": "Copiar",
	"dialog.open_url": "Abrir URL",
	"reference_image.image": "Imagem",
	"uv_editor.rotate_uv": "Girar UV",
	"generic.error": "Erro",
	"projects.start_screen": "Iniciar tela",
	"message.invalid_link.message": "O modelo compartilhado \"%0\" que está tentando carregar é inválido ou expirou.",
	"message.plugin_dependencies.title": "Dependências de plugin",
	"message.plugin_dependencies.message1": "O plugin requer as seguintes dependências:",
	"message.plugin_dependencies.message1_update": "O plugin %0 foi atualizado e agora requer as seguintes dependências:",
	"message.plugin_dependencies.message2": "Deseja instalá-los para continuar?",
	"message.plugin_dependencies.invalid": "Infelizmente, o plugin não pode ser instalado. Há uma dependência inválida nele:",
	"message.preview_scene_load_failed": "Falha ao carregar a cena de pré-visualização. Verifique a conexão com a internet.",
	"dialog.convert_project.text1": "Converter o projeto em um formato diferente.",
	"dialog.convert_project.text2": "Use a conversão por sua conta e risco. Os formatos têm diferentes características e restrições, por isso a conversão em alguns casos quebrará partes do seu projeto.",
	"dialog.convert_project.text3": "A conversão não pode ser desfeita. Por padrão, uma cópia será criada.",
	"dialog.unsaved_work.title": "Trabalho não salvo",
	"dialog.unsaved_work.text": "Os projetos têm mudanças não salvas. Deseja salvar suas alterações?",
	"dialog.unsaved_work.discard_all": "Descartar tudo",
	"dialog.unsaved_work.save_all": "Salvar tudo",
	"dialog.resize_texture.mode": "Modo",
	"dialog.resize_texture.mode.crop": "Recortar/Expandir",
	"dialog.resize_texture.mode.scale": "Escala",
	"dialog.plugins.is_installed": "Instalado",
	"dialog.plugins.is_disabled": "Desabilitado",
	"dialog.plugins.disable": "Desativar",
	"dialog.plugins.enable": "Ativar",
	"dialog.plugins.dependencies": "Dependências em:",
	"dialog.view_backups.open_folder": "Abrir pasta",
	"dialog.share_model.reference_images": "Incluir imagem de referência",
	"dialog.share_model.too_large": "Falha ao enviar: O modelo é muito grande",
	"dialog.share_model.too_large_references": "Falha ao enviar: O modelo é muito grande. Tente sem as imagens de referência.",
	"settings.stretch_linked": "Vincular esticamento",
	"settings.stretch_linked.desc": "Estica o cubo em todas as direções com o mesmo valor",
	"settings.grids": "Mostrar grades",
	"settings.grids.desc": "Mostrar ou ocultar todas as grades 3D",
	"settings.double_click_switch_tools": "Alternar ferramentas com um clique duplo",
	"settings.double_click_switch_tools.desc": "Clique duas vezes na área de visualização para alternar entre as ferramentas.",
	"settings.outlines_in_paint_mode": "Contornos de seleção no modo de pintura",
	"settings.outlines_in_paint_mode.desc": "Mostra contornos de seleção de elementos no modo de pintura.",
	"settings.json_indentation": "Indentação JSON",
	"settings.json_indentation.desc": "Estilo de recuo para arquivos JSON exportados.",
	"settings.json_indentation.tabs": "Abas",
	"settings.json_indentation.spaces_4": "Espaços: 4",
	"settings.json_indentation.spaces_2": "Espaços: 2",
	"action.slider_stretch": "Esticar",
	"action.slider_stretch.desc": "Estica os cubos multiplicativamente no eixo %0 sem alterar as coordenadas UV.",
	"action.view_backups": "Ver backups",
	"action.view_backups.desc": "Navega pela lista de backups de projetos salvos automaticamente.",
	"action.search_outliner": "Lista de tópicos de pesquisa",
	"action.search_outliner.desc": "Pesquisa nomes de elementos específicos no painel de estrutura de tópicos.",
	"action.mirror_modeling": "Modelagem espelhada",
	"action.mirror_modeling.desc": "Ativa a modelagem espelhada no eixo X. Todas as alterações feitas na área de visualização serão refletidas no outro lado, a menos que sejam especificamente desativadas no elemento.",
	"action.allow_element_mirror_modeling": "Permitir modelagem espelhada",
	"action.allow_element_mirror_modeling.desc": "Escolha se os elementos selecionados podem ser afetados pela modelagem espelhada.",
	"action.switch_face_crease": "Alternar vinco da face",
	"action.switch_face_crease.desc": "Alterna a direção em que o quadrilátero dobra ao meio.",
	"action.clear_unused_texture_space": "Limpar espaço inutilizado da textura",
	"action.clear_unused_texture_space.desc": "Limpa as partes da textura que não estão mapeadas por UV a nenhum elemento.",
	"action.split_screen": "Divisão da tela",
	"action.split_screen.desc": "Seleciona uma área de visualização no modo divisão de tela.",
	"action.split_screen.single": "Única",
	"action.split_screen.double_horizontal": "Dupla horizontal",
	"action.split_screen.double_vertical": "Dupla vertical",
	"action.split_screen.quad": "Quatro",
	"action.split_screen.triple_left": "Três (esquerda)",
	"action.split_screen.triple_right": "Três (direita)",
	"action.split_screen.triple_top": "Três (topo)",
	"action.split_screen.triple_bottom": "Três (inferior)",
	"action.uv_project_from_view": "Projeção UV da visualização",
	"action.uv_project_from_view.desc": "Gera UVs automaticamente para as faces selecionadas a partir da perspectiva da visualização 3D.",
	"action.graph_editor_other_graphs": "Mostrar outros gráficos",
	"action.graph_editor_other_graphs.desc": "Define se os gráficos dos eixos não selecionados são mostrados.",
	"action.graph_editor_include_other_graphs": "Incluir outros gráficos",
	"action.graph_editor_include_other_graphs.desc": "Define se o editor de gráficos inclui na visualização os gráficos que não estão selecionados.",
	"action.set_ik_source": "Definir IK Root",
	"action.set_ik_source.desc": "Seleciona o osso raiz da cadeia que deve ser movido por esse objeto nulo através da cinemática inversa.",
	"edit.loop_cut.cuts": "Cortes",
	"panel.element.stretch": "Esticar",
	"preview_scene.minecraft_plains": "Planícies",
	"preview_scene.minecraft_cherry_grove": "Cerejal",
	"preview_scene.minecraft_snowy_tundra": "Tundra nevada",
	"preview_scene.minecraft_sunset": "Pôr do sol",
	"preview_scene.minecraft_night": "Noite",
	"preview_scene.minecraft_desert": "Deserto",
	"preview_scene.minecraft_underwater": "Submerso",
	"preview_scene.minecraft_coral_reef": "Recife de corais",
	"preview_scene.minecraft_lush_cave": "Cavernas verdejantes",
	"preview_scene.minecraft_deep_dark": "Profundezas sombrias",
	"generic.navigate_forward": "Avançar",
	"generic.navigate_back": "Voltar",
	"action.element_render_order": "Ordem de renderização de transparência",
	"action.element_render_order.default": "Auto.",
	"action.element_render_order.behind": "Atrás",
	"action.element_render_order.in_front": "Na frente",
	"message.installing_update.title": "Atualização disponível",
	"message.installing_update.message": "Uma nova versão já está disponível para ser instalada. Após fechar o aplicativo, aguarde cerca de %0 segundos antes de abrir o Blockbench novamente ou desligar o computador, para que a atualização seja instalada.",
	"settings.brush_cursor_2d": "Pincel 2D (Cursor)",
	"settings.brush_cursor_2d.desc": "Mostra um contorno ao redor do pincel na área de trabalho 2D",
	"settings.brush_cursor_3d": "Pincel 3D (Cursor)",
	"settings.brush_cursor_3d.desc": "Mostra um contorno ao redor do pincel na área de trabalho 3D",
	"settings.cdn_mirror": "Usar espelho CDN",
	"settings.cdn_mirror.desc": "Usa o espelho CDN para baixar os plugins. Ele recebe atualizações mais rapidamente e funciona em algumas regiões onde o padrão não está acessível.",
	"data.layer": "Camada",
	"data.panel": "Painel",
	"generic.confirm_delete": "Deseja mesmo apagar isso?",
	"format_category.general": "Geral",
	"modifier_actions.no_uniform_scaling": "Escala livre",
	"message.texture_refresh_conflict.title": "Versões de textura conflitantes",
	"message.texture_refresh_conflict.message": "O arquivo de textura pode ter alterações que conflitam com a versão do Blockbench",
	"message.texture_refresh_conflict.keep_ours": "Manter a versão do Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "Carrega arquivo e descarta todas as alterações e camadas no Blockbench",
	"message.group_required_to_animate": "Você não pode animar esse tipo de elemento. Crie um grupo ou armadura para animá-lo.",
	"dialog.texture.uv_size": "Tamanho UV",
	"dialog.advanced_screenshot.angle_preset": "Ângulo predefinido",
	"dialog.advanced_screenshot.resolution": "Resolução",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom para ajustar",
	"dialog.advanced_screenshot.zoom": "Zoom / Distância focal",
	"dialog.advanced_screenshot.anti_aliasing": "Suavização",
	"dialog.advanced_screenshot.anti_aliasing.off": "Não",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multiamostragem (MSAA)",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Superamostragem (SSAA)",
	"dialog.advanced_screenshot.show_gizmos": "Mostrar gizmos de edição",
	"dialog.advanced_screenshot.shading": "Sombreamento",
	"settings.auto_keyframe": "Quadro-chave auto.",
	"settings.auto_keyframe.desc": "Cria automaticamente um quadro-chave com valores padrões no início da linha do tempo ao transformar o osso em um ponto posterior.",
	"settings.modded_entity_integer_size": "Tamanho inteiro da entidade modificada",
	"settings.modded_entity_integer_size.desc": "Limita os tamanhos de cubo no formato entidade modificada a números inteiros. Embora números flutuantes sejam tecnicamente suportados em algumas versões, os inteiros são muito mais fáceis de mapear UV.",
	"category.layers": "Camadas",
	"keybind.paint_secondary_color": "Pintar com cor secundária.",
	"action.selection_tool_operation_mode": "Modo de operação de seleção",
	"action.selection_tool_operation_mode.create": "Nova seleção",
	"action.selection_tool_operation_mode.add": "Adicionar à seleção",
	"action.selection_tool_operation_mode.subtract": "Subtrair da seleção",
	"action.selection_tool_operation_mode.intersect": "Interseção",
	"action.pixel_perfect_drawing": "Desenho preciso de pixel",
	"action.pixel_perfect_drawing.desc": "Desenhe linhas lisas de pixel-art sem píxeis duplos nas curvas",
	"action.selection_tool": "Ferramenta de seleção",
	"action.selection_tool.desc": "Seleciona as partes da imagem",
	"action.selection_tool.rectangle": "Retângulo",
	"action.selection_tool.ellipse": "Elipse",
	"action.selection_tool.lasso": "Laço seletor",
	"action.selection_tool.wand": "Varinha mágica",
	"action.selection_tool.color": "Seletor de cor",
	"action.move_layer_tool": "Mover camada",
	"action.move_layer_tool.desc": "Mover a camada ou seleção atual",
	"action.export_modded_animations": "Exportar animações de entidades modificadas",
	"action.export_modded_animations.desc": "Exportar animações para um modelo de entidades modificadas do Minecraft Java Edition",
	"action.swap_colors": "Trocar cores",
	"action.swap_colors.desc": "Troca a cor principal com a cor secundária",
	"action.apply_mesh_rotation": "Aplicar rotação",
	"action.apply_mesh_rotation.desc": "Redefine a rotação do elemento da malha e a aplica à geometria.",
	"action.flip_texture_x.desc": "Virar a textura ou camada horizontalmente",
	"action.flip_texture_y.desc": "Virar a textura ou camada verticalmente",
	"action.rotate_texture_cw.desc": "Girar a textura ou camada no sentido horário",
	"action.rotate_texture_ccw.desc": "Girar a textura ou camada no sentido anti-horário",
	"action.crop_texture_to_selection": "Cortar textura para seleção",
	"action.create_empty_layer": "Criar camada vazia",
	"action.enable_texture_layers": "Ativar camadas",
	"action.disable_texture_layers": "Desativar camadas",
	"action.layer_opacity": "Opacidade da camada",
	"action.layer_to_texture_size": "Expandir camada para o tamanho da textura",
	"action.layer_to_texture_size.desc": "Expande a camada para o tamanho da textura",
	"action.merge_layer_down": "Mesclagem inferior",
	"action.merge_layer_down.desc": "Mescla a camada abaixo",
	"action.advanced_screenshot": "Captura de tela avançada...",
	"action.advanced_screenshot.desc": "Faz uma captura de tela do modelo com opções avançadas",
	"action.bake_ik_animation": "Aplicar cinemática inversa",
	"action.bake_ik_animation.desc": "Aplica as rotações usadas pela cinemática inversa para a animação selecionada.",
	"action.save_animation_preset": "Salvar predefinição de animação...",
	"action.save_animation_preset.desc": "Salva os quadros-chave como uma predefinição de animação",
	"action.animation_onion_skin": "Animação onion skin",
	"action.animation_onion_skin.desc": "Mostra a visualização da estrutura de arame de um quadro diferente na animação para referência",
	"action.apply_animation_preset": "Aplicar animação predefinida",
	"action.apply_animation_preset.desc": "Seleciona em uma lista de predefinições de animação e aplica ao osso selecionado.",
	"menu.brush_presets.pixel_perfect": "Pincel de píxel preciso",
	"panel.layers": "Camadas",
	"uv_editor.copy_paste_tool.to_layer": "Para nova camada",
	"format.image.new": "Criar nova imagem",
	"format.image.info.summary": "O editor de imagens 2D permite criar e editar imagens e pixel-art diretamente no Blockbench, sem a precisar de um editor de imagens externo. Edite imagens, modifique texturas ou crie sua própria pixel-art!",
	"settings.move_with_selection_tool": "Usar ferramenta de seleção para mover seleções",
	"settings.move_with_selection_tool.desc": "Permite que a ferramenta de seleção mova as seleções diretamente, sem precisar alternar para a ferramenta de mover camada.",
	"settings.final_newline": "Última linha",
	"settings.final_newline.desc": "Insere um caractere de nova linha no final dos arquivos exportados.",
	"action.crop_layer_to_selection": "Camada de corte para seleção",
	"action.edit_mode_uv_overlay.desc": "Mostra o mapa UV como uma sobreposição no modo de edição.",
	"menu.image": "Imagem",
	"menu.texture.discard_changes": "Descartar mudanças",
	"menu.texture.discard_changes.desc": "Descarta todas as alterações não salvas e carrega a versão mais recente do arquivo.",
	"panel.textures.images": "Imagens",
	"dialog.advanced": "Avançado",
	"dialog.recommended_option": "recomendado",
	"modifier_actions.snap_to_center": "Ajustar ao centro",
	"modifier_actions.snap_to_pixels": "Ajustar aos píxeis",
	"message.invalid_format.install_plugin": "Instalar plugin '%0'",
	"message.plugin_deprecated.message": "Deseja mesmo instalar esse plugin obsoleto?",
	"message.plugin_deprecated.install_anyway": "Instalar mesmo assim",
	"message.image_editor.not_found": "Não foi possível encontrar o editor de imagens selecionado. Selecione outra opção.",
	"message.knife_tool.confirm": "Pressione %0 ou clique aqui para aplicar a ferramenta bisturi",
	"message.knife_tool.skipped_face": "Não é possível cortar entre faces diferentes. Inclua as arestas ou vértices entre elas!",
	"message.optimize_animation.keyframes_removed": "%0 quadro(s)-chave reduntante(s) removido(s)",
	"message.optimize_animation.nothing_to_optimize": "Não há nada para otimizar!",
	"message.duplicate_bone_copy_animation.title": "Copiar animação",
	"message.duplicate_bone_copy_animation.message": "O osso duplicado é animado em %0 animação(ões). Deseja copiar os quadros-chave para o novo osso?",
	"message.auto_fix_mesh_edit.title": "Correção automática",
	"message.auto_fix_mesh_edit.revert": "Reverter edição",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Alguns vértices foram movidos para o mesmo local. Como deseja prosseguir?",
	"message.auto_fix_mesh_edit.concave_quads": "Uma ou mais faces quadriláteras agora estão côncavas. Isso pode causar problemas no mapeamento UV e na renderização. O Blockbench pode corrigir isso automaticamente para você:",
	"message.auto_fix_mesh_edit.merge_vertices": "Unir vértices",
	"message.auto_fix_mesh_edit.split_quads": "Dividir quadriláteros",
	"message.load_images.add_image": "Adicionar imagem",
	"dialog.project.modded_entity_entity_class": "Classe da entidade",
	"dialog.resize_texture.offset": "Compensar",
	"dialog.animated_texture_editor.code_reference": "Código de referência",
	"dialog.animated_texture_editor.code_reference.about": "Esse código é usado para implementar a animação de textura gerada como referência e não funciona necessariamente sem modificações. Consulte a documentação para saber mais.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentação",
	"dialog.animated_texture_editor.reframe": "Reenquadrar",
	"dialog.animated_texture_editor.stride": "Tamanho do quadro",
	"dialog.animated_texture_editor.frames": "Número de quadros",
	"dialog.animated_texture_editor.add_frame": "Adicionar quadro",
	"dialog.animated_texture_editor.resize_frames": "Redimensionar quadros...",
	"dialog.animated_texture_editor.apply": "Aplicar",
	"dialog.add_primitive.edge_size": "Tamanho da aresta",
	"dialog.change_animation_speed.speed": "Velocidade",
	"dialog.change_animation_speed.adjust_snapping": "Ajustar encaixe",
	"dialog.optimize_animation.selection": "Seleção",
	"dialog.optimize_animation.selection.selected_keyframes": "Quadros-chave selecionados",
	"dialog.optimize_animation.selection.selected_animation": "Animação selecionada",
	"dialog.optimize_animation.selection.all_animations": "Todas as animações",
	"dialog.optimize_animation.thresholds": "Valores de limiar",
	"dialog.import_obj.obj": "Arquivo OBJ",
	"dialog.import_obj.mtl": "Arquivo MTL",
	"dialog.import_obj.scale": "Escala",
	"layout.thumbnail": "Miniatura CSS personalizada",
	"settings.pixel_grid": "Grade de píxeis",
	"settings.pixel_grid.desc": "Mostra a grade de píxeis da textura nos elementos no modo de edição.",
	"settings.image_editor_grid_size": "Tamanho da grade do editor de imagens",
	"settings.image_editor_grid_size.desc": "Tamanho da grade maior no editor de imagens 2D",
	"settings.ground_plane_double_side": "Plano de chão em dupla face",
	"settings.ground_plane_double_side.desc": "Torna o plano do chão visível",
	"settings.optifine_save_default_texture": "OptiFine JEM: Exportar textura selecionada",
	"settings.optifine_save_default_texture.desc": "Exporta a textura selecionada como a textura padrão do modelo.",
	"action.slider_color_select_threshold": "Limiar de seleção de cor",
	"action.slider_color_select_threshold.desc": "A proximidade da cor de um píxel ao lado para que ele seja selecionado por cor ou pela varinha mágica.",
	"action.stretch_tool": "Esticar",
	"action.stretch_tool.desc": "Usada para selecionar e esticar elementos.",
	"action.knife_tool": "Bisturi",
	"action.knife_tool.desc": "Usada para cortar faces de malha em peças menores.",
	"action.duplicate_project": "Duplicar projeto",
	"action.duplicate_project.desc": "Crie uma cópia do projeto aberto.",
	"action.transform_space.parent": "Parente",
	"action.transform_pivot_space": "Espaço de transformação de pivô",
	"action.solidify_mesh_selection": "Solidificar faces",
	"action.solidify_mesh_selection.desc": "Solidifique as faces selecionadas da malha.",
	"action.animated_texture_editor": "Editor flipbook...",
	"action.animated_texture_editor.desc": "Edite a animação flipbook da textura selecionada.",
	"action.center_individual_pivots": "Pivôs individuais centrais",
	"action.center_individual_pivots.desc": "Define o ponto de pivô de cada elemento selecionado como seu centro.",
	"action.uv_cycle": "Ciclo UV",
	"action.uv_cycle.desc": "Percorra a ordem dos vértices UV sem alterar as posições UV.",
	"action.uv_cycle_invert": "Ciclo UV invertido",
	"action.uv_cycle_invert.desc": "Inverta a ordem dos vértices UV sem alterar as posições UV.",
	"action.slider_animation_controller_speed": "Velocidade de reprodução do controlador",
	"action.slider_animation_controller_speed.desc": "A velocidade de reprodução dos controladores de animação em porcentagem",
	"action.optimize_animation": "Otimizar animação",
	"action.optimize_animation.desc": "Otimize a animação atual e reduza o número de quadros-chave.",
	"action.change_animation_speed": "Alterar velocidade da animação...",
	"action.change_animation_speed.desc": "Altera a velocidade da animação selecionada.",
	"timeline.select_particle_file": "Selecionar arquivo de partícula",
	"timeline.select_sound_file": "Selecionar arquivo de som",
	"menu.cube.texture.default": "Padrão",
	"menu.texture.particle.clear": "Parar partículas",
	"menu.texture.use_as_default": "Definir como padrão",
	"menu.texture.use_as_default.clear": "Desatribuir como padrão",
	"menu.toolbar.overflow": "Barra de ferramentas sobrecarregada",
	"edit.solidify_mesh_selection.thickness": "Espessura",
	"reference_image.sync_to_timeline": "Sincronizar para a linha do tempo",
	"reference_image.toggle_playback": "Reproduzir/Pausar",
	"dialog.add_primitive.shape.beveled_cuboid": "Cuboide biselado",
	"dialog.ignore_all": "Ignorar tudo",
	"data.texture_group": "Grupo de textura",
	"data.animation": "Animação",
	"generic.on": "Sim",
	"generic.off": "Não",
	"format.free.info.3d_printing": "Impressão 3D",
	"message.invalid_file.merge_conflict": "O arquivo contém conflitos de mesclagem Git não resolvidos.",
	"dialog.expand_texture_selection.radius": "Quantidade",
	"dialog.expand_texture_selection.corner": "Formato de canto",
	"dialog.expand_texture_selection.corner.round": "Redondo",
	"dialog.expand_texture_selection.corner.square": "Quadrado",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Fundir em",
	"keybindings.variation_conflict": "A variação entra em conflito com a tecla de atalho principal",
	"settings.recovery_save_interval": "Intervalo de salvamento do ponto de recuperação",
	"settings.recovery_save_interval.desc": "O Blockbench salva regularmente o projeto aberto em segundo plano para recuperação em caso de falha do computador. Defina o intervalo em segundos. Utilize 0 para desativar o salvamento.",
	"settings.save_view_per_tab": "Salvar visualização por aba",
	"settings.save_view_per_tab.desc": "Salve o ângulo de visão atual para cada aba separadamente.",
	"settings.inherit_parent_color": "Herdar a cor do derivador",
	"settings.inherit_parent_color.desc": "Defina a cor do marcador de um elemento recém-criado para a cor do elemento derivador ao invés de uma cor aleatória.",
	"keybind.preview_select.multi_select": "Seleção múltipla",
	"keybind.preview_select.group_select": "Seleção em grupo",
	"keybind.preview_select.loop_select": "Seleção de loop",
	"action.fill_mode.selection": "Seleção",
	"action.fill_mode.selected_elements": "Elementos selecionados",
	"action.image_tiled_view": "Visualização em mosaico",
	"action.image_tiled_view.description": "Ativa a visualização em mosaico no editor 2D.",
	"action.image_onion_skin_view": "Editor de imagens onion skin",
	"action.image_onion_skin_view.description": "Ativa a visualização em camadas (onion skin) no editor 2D.",
	"action.expand_texture_selection": "Expandir seleção de textura",
	"action.expand_texture_selection.desc": "Expande ou reduzir a seleção de texturas",
	"action.switch_tabs.reverse_order": "Ordem inversa",
	"action.save_project_incremental": "Salvar projeto com incremento",
	"action.save_project_incremental.desc": "Salva o modelo atual como um arquivo de projeto com um incremento (p. ex.: project_2.bbmodel).",
	"action.copy.multiple": "Copiar tudo",
	"action.copy.multiple.desc": "Copiar todos os dados disponíveis individualmente",
	"action.paste.multiple": "Colar tudo",
	"action.randomize_marker_colors": "Aleatorizar as cores dos marcadores",
	"action.cube_light_emission": "Emissão de luz",
	"action.cube_light_emission.desc": "Altera a emissividade dos cubos selecionados, com um valor entre 0 e 15.",
	"action.view_mode.colored_solid": "Sólido com cores de marcador",
	"action.focus_on_selection.rotate_only": "Apenas girar",
	"action.create_texture_group": "Criar grupo de textura",
	"action.create_texture_group.desc": "Crie um grupo para suas texturas.",
	"action.uv_maximize.all_faces": "Afeta todas as faces",
	"action.retarget_animators": "Animações de redirecionamento",
	"action.retarget_animators.desc": "Seleciona qual animador tem como alvo o osso ou elemento.",
	"action.merge_animation": "Mesclar animações",
	"action.merge_animation.desc": "Mescle a animação com outra.",
	"action.add_keyframe.reset_values": "Com valores padrões",
	"action.set_timeline_range_start": "Definir intervalo de tempo de início da linha do tempo",
	"action.set_timeline_range_start.desc": "Defina o ponto inicial para um intervalo de reprodução personalizado na linha do tempo da animação.",
	"action.set_timeline_range_end": "Definir fim do intervalo da linha do tempo",
	"action.set_timeline_range_end.desc": "Define o ponto final para um intervalo de reprodução personalizado na linha do tempo da animação.",
	"action.disable_timeline_range": "Desativar fim do intervalo da linha do tempo",
	"action.disable_timeline_range.desc": "Desativa o intervalo de reprodução personalizado na linha do tempo da animação.",
	"menu.texture_group.resolve": "Resolver",
	"menu.image_tiled_view.mirrored": "Arestas espelhadas",
	"menu.image_onion_skin_view.frame": "Quadros",
	"menu.image_onion_skin_view.frame.last_viewed": "Último quadro visualizado",
	"menu.image_onion_skin_view.frame.previous": "Quadro anterior",
	"menu.image_onion_skin_view.frame.next": "Próximo quadro",
	"menu.image_onion_skin_view.frame.both": "Anterior + Próximo",
	"menu.image_onion_skin_view.display": "Exibição",
	"menu.image_onion_skin_view.display.pixels": "Píxeis menores",
	"menu.image_onion_skin_view.display.transparent": "Transparente",
	"menu.image_onion_skin_view.above": "Mostrar acima",
	"menu.animation.reload": "Recarregar",
	"switches.autouv.alt": "Relativo",
	"display.rotation_pivot": "Pivô de rotação",
	"display.scale_pivot": "Pivô de escala",
	"display.reference.fox": "Raposa",
	"display.reference.eating": "Comendo",
	"preview_scene.sky": "Céu",
	"preview_scene.space": "Espaço",
	"preview_scene.minecraft_ocean": "Oceano",
	"message.import_palette.selection_only": "Apenas seleção",
	"dialog.blend_transition_edit.ease_in_out": "Suavizar início e fim (%0)",
	"dialog.blend_transition_edit.generate": "Gerar...",
	"dialog.blend_transition_edit.generate.learn_more": "Mais informações e pré-visualização",
	"dialog.blend_transition_edit.generate.curve": "Tipo de suavização",
	"dialog.blend_transition_edit.generate.steps": "Quadros-chave",
	"settings.fps_limit": "Limite de QPS",
	"settings.fps_limit.desc": "Limita a quantidade de quadros por segundo que o Blockbench renderiza. A taxa de quadros real é limitada pela capacidade de exibição do seu dispositivo.",
	"settings.outliner_reveal_on_select": "Revelar elementos ao selecionar",
	"settings.outliner_reveal_on_select.desc": "Revela os elementos no painel de estrutura de tópicos quando selecionados.",
	"settings.java_export_pivots": "Exportar pivôs em modelos de bloco/item Java",
	"settings.java_export_pivots.desc": "Salva pontos de pivô em modelos de bloco/item Java em cubos sem rotação.",
	"animation_controllers.state.blend_transition_curve": "Curva de transição de mistura",
	"menu.slider.reset_vector": "Redefinir vetor",
	"dialog.blend_transition_edit.extended": "Gráfico estendido",
	"message.screenshot_too_large.title": "Problema de resolução de captura de tela",
	"message.screenshot_too_large.message": "Não foi possível renderizar a captura de tela. Tente novamente com uma resolução menor ou sem superamostragem (SSAA).",
	"message.rename_elements.numbering": "Você pode usar caracteres especiais para gerar números sequenciais. Use % para obter o índice do elemento dentro do seu grupo e $ para obter o índice dentro da seleção.",
	"generic.edit_externally": "Editar externamente",
	"message.settings_require_restart.title": "Reinicialização necessária",
	"message.settings_require_restart.message": "Algumas configurações só serão aplicadas após reiniciar o programa.",
	"message.settings_require_restart.restart_now": "Reiniciar agora",
	"message.settings_require_restart.restart_later": "Reiniciar depois",
	"message.classroom_mode.install_plugin": "Não é possível instalar os plugins no modo Sala de Aula.",
	"dialog.collection.export_path": "Exportar caminho",
	"dialog.collection.select_all": "Selecionar tudo",
	"dialog.collection.select_none": "Não selecionar",
	"dialog.collection.add_with_filter": "Adicionar com filtro",
	"dialog.collection.remove": "Remover",
	"dialog.material_config.title": "Configuração de material",
	"dialog.material_config.color_value": "Valor da cor",
	"dialog.material_config.mer": "Metal-Emissivo-Rugosidade",
	"dialog.material_config.mer_value": "Valor MER",
	"dialog.material_config.depth_type": "Tipo de profundidade",
	"dialog.create_texture.disable_mirror_uv": "Desativar espelhamento UV",
	"dialog.create_texture.disable_mirror_uv.desc": "Desativa a opção espelhamento UV na modelagem espelhada para preservar UVs separadas para cada lado do modelo.",
	"dialog.create_gif.turn.sync_to_anim_length": "Sincronizar com o comprimento da animação",
	"settings.category.controls": "Controles",
	"settings.classroom_mode": "Modo sala de aula",
	"settings.classroom_mode.desc": "Restringe as funcionalidades, como a instalação de plugins, e remove links para mídias sociais",
	"settings.antialiasing_bleed_fix": "Corrigir vazamento de textura",
	"settings.antialiasing_bleed_fix.desc": "Corrige o vazamento de texturas ao usar anti-serrilhamento. Pode ter incompatibilidade com hardware mais antigo.",
	"settings.tone_mapping": "Mapeamento de tons",
	"settings.tone_mapping.desc": "Método de aproximação para mostrar alta faixa dinâmica em uma tela padrão para renderização PBR.",
	"settings.audio_scrubbing": "Linha do tempo de reprodução de áudio",
	"settings.audio_scrubbing.desc": "Reproduz trechos curtos do áudio enquanto navega pela linha do tempo.",
	"settings.viewport_rotate_speed": "Velocidade de rotação da área de visualização",
	"settings.viewport_rotate_speed.desc": "Sensibilidade de entrada ao rotacionar na área de visualização.",
	"settings.viewport_zoom_speed": "Velocidade do zoom na área de visualização",
	"settings.viewport_zoom_speed.desc": "Sensibilidade de entrada ao ampliar a área de visualização",
	"settings.editor_2d_zoom_speed": "Velocidade do zoom no editor 2D",
	"settings.editor_2d_zoom_speed.desc": "Sensibilidade de entrada ao aplicar zoom no editor de pintura UV e 2D.",
	"category.select": "Selecionar",
	"action.vertex_snap_mode.rotate": "Girar",
	"action.export_image": "Exportar imagem",
	"action.export_image.desc": "Exporta sua textura como um arquivo de imagem",
	"action.apply_mirror_modeling": "Aplicar modelo espelhado",
	"action.apply_mirror_modeling.desc": "Aplica um modelo espelhado para a seleção. Todos os elementos selecionados serão copiados e invertidos em relação ao eixo X.",
	"action.create_collection": "Criar coleção",
	"action.create_collection.desc": "Cria uma coleção a partir da seleção delineada.",
	"action.set_collection_content_to_selection": "Definir conteúdo da coleção para selecionado",
	"action.set_collection_content_to_selection.desc": "Define os grupos e elementos selecionados como o conteúdo da coleção.",
	"action.add_to_collection": "Adicionar seleção à coleção",
	"action.add_to_collection.desc": "Adiciona os grupos e elementos selecionados para a coleção.",
	"action.view_mode.material": "Pré-visualizar material",
	"action.create_material": "Criar material",
	"action.create_material.desc": "Cria um novo material PBR fora da textura selecionada",
	"action.generate_pbr_map": "Gerar mapa PBR...",
	"action.generate_pbr_map.desc": "Gera um mapa PBR (mapa de altura ou metalização, emissividade, rugosidade) a partir de uma textura existente.",
	"menu.tools.main_tools": "Caixa de ferramentas",
	"menu.view.panels": "Paineis",
	"menu.texture.pbr_channel": "Canal PBR",
	"menu.texture.pbr_channel.color": "Cor",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Altura",
	"menu.texture.pbr_channel.mer": "MER (Metal-Emissivo-Rugosidade)",
	"menu.texture.pbr_channel.mer_subsurface": "Subsuperfície MER",
	"menu.collection.export_project": "Exportar projeto",
	"menu.collection.export_as": "Exportar como \"%0\"",
	"menu.panel.enable": "Ativado",
	"menu.panel.move_to": "Mover para",
	"menu.panel.move_to.left_bar": "Barra lateral esquerda",
	"menu.panel.move_to.right_bar": "Barra lateral direita",
	"menu.panel.move_to.top": "Topo",
	"menu.panel.move_to.bottom": "Baixo",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Ocultar",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origem",
	"menu.mirror_modeling.mirror_uv": "Espelho UV",
	"menu.animation_onion_skin.frames": "Molduras",
	"menu.animation_onion_skin.select": "Selecionar",
	"menu.animation_onion_skin.previous": "Anterior",
	"menu.animation_onion_skin.next": "Próximo",
	"menu.animation_onion_skin.previous_next": "Anterior + Próximo",
	"menu.animation_onion_skin.count": "Quantidade",
	"menu.animation_onion_skin.interval": "Intervalo",
	"menu.animation_onion_skin_selective": "Onion skin seletiva",
	"menu.animation_onion_skin_selective.desc": "Mostra apenas a onion skin para a parte selecionada do modelo.",
	"edit.loop_cut.unit": "Unidade",
	"edit.loop_cut.unit.size_units": "Tamanho das unidades",
	"edit.loop_cut.unit.percent": "Percentual",
	"edit.extrude_mesh_selection.direction": "Direção",
	"edit.extrude_mesh_selection.direction.outwards": "Para fora",
	"edit.extrude_mesh_selection.direction.average": "Média",
	"edit.extrude_mesh_selection.even_extend": "Extensão uniforme",
	"edit.vertex_snap.align": "Alinhar",
	"edit.vertex_snap.align.longest": "Eixo mais longo",
	"edit.vertex_snap.align.direction": "Direção a partir do pivô",
	"edit.vertex_snap.align.align_axis": "%0 eixos",
	"edit.vertex_snap.ignore_axis": "Ignorar eixos",
	"codec.common.format": "Formato",
	"codec.image.quality": "Qualidade",
	"panel.collections": "Coleções",
	"modifier_actions.always": "Sempre ativado",
	"modifier_actions.unless": "A menos que %0",
	"settings.undo_selections": "Desfazer seleção",
	"settings.undo_selections.desc": "Acompanhe as alterações de seleção como uma etapa no histórico de desfazer.",
	"action.focus_on_selection.zoom": "Zoom para ajustar",
	"display.reference.tooting": "Alardeando",
	"settings.selection_tolerance": "Seleção de tolerância",
	"settings.selection_tolerance.desc": "Tamanho da área que pode ser clicada para selecionar uma aresta ou vértice",
	"action.delete.keep_vertices": "Manter arestas/vértices",
	"menu.mesh": "Malha",
	"dialog.material_config.subsurface": "Dispersão subsuperficial",
	"dialog.material_config.subsurface_enabled.desc": "Usa o canal alfa do mapa MER para espalhamento subsuperficial",
	"settings.pick_combined_color": "Selecionar a cor combinada",
	"settings.pick_combined_color.desc": "Selecione a cor combinada de todas as camadas no respectivo píxel, em vez da cor na camada ativa.",
	"action.split_rgb_into_layers": "Dividir canais RGB em camadas",
	"action.split_rgb_into_layers.desc": "Divide a textura em camadas aditivas, uma para cada canal RGB.",
	"dialog.project.java_block_version": "Versão de formato",
	"data.spline_mesh": "Ranhura",
	"data.billboard": "Painel",
	"data.armature": "Armação",
	"data.armature_bone": "Armação de osso",
	"generic.reload": "Recarregar",
	"modifier_actions.subtract": "Subtrair",
	"modifier_actions.reduced_intensity": "Ajuste fino",
	"modifier_actions.select_bone": "Selecionar osso",
	"modifier_actions.spline_select_multiple_points": "Selecione vários pontos ou curvas.",
	"modifier_actions.move_panel_without_docking": "Mover sem encaixe",
	"message.save_all_textures.message": "Deseja salvar cada uma destas texturas?",
	"message.save_all_textures.skip": "Pular",
	"dialog.add_spline.shape": "Formato",
	"dialog.add_spline.shape.segment": "Segmento",
	"dialog.add_spline.shape.square": "Retângulo",
	"dialog.add_spline.shape.circle": "Círculo",
	"dialog.add_spline.diameter": "Diâmetro",
	"dialog.add_spline.sides_tubular": "Segmentos de tubo",
	"dialog.add_spline.sides_radial": "Segmentos de anel",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Altura",
	"dialog.add_spline.width": "Largura",
	"dialog.plugins.revoke_permissions": "Revogar permissões",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minificar",
	"dialog.expression_editor.find_replace": "Buscar/Substituir",
	"dialog.create_gif.show_gizmos": "Gravar gizmos e grade",
	"dialog.preview_options.title": "Pré-visualizar opções",
	"dialog.preview_options.background": "Fundo",
	"dialog.preview_options.background.checkerboard": "Quadriculado",
	"dialog.preview_options.background.solid": "Sólido",
	"dialog.preview_options.background.custom_color": "Cor personalizada",
	"dialog.preview_options.show_gizmos": "Mostrar gizmos",
	"dialog.skin.texture_source": "Textura de origem",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Arquivo de textura",
	"dialog.convert_skin.adjust_texture": "Ajustar textura",
	"dialog.settings.clear_profile_value": "Limpar valor do perfil",
	"layout.section.customize": "Personalizar",
	"layout.theme.configure": "Configurar",
	"layout.color.elevated": "Elevado",
	"layout.color.elevated.desc": "Geralmente, os elementos UI elevados são separados por quebra de sombra",
	"layout.file.watch_changes": "Ver alterações e recarregar",
	"settings.autocomplete_code": "Preenchimento automático de código",
	"settings.autocomplete_code.desc": "Mostra sugestões de autopreenchimento em editores de código",
	"settings.detect_flipbook_textures": "Detectar texturas do folioscópio",
	"settings.detect_flipbook_textures.desc": "Detectar automaticamente as texturas animadas do folioscópio e visualizá-las como animação.",
	"settings.double_click_select_reference": "Seleciona a imagem de referência ao clicar duas vezes",
	"settings.double_click_select_reference.desc": "Clique duas vezes na área de visualização para selecionar uma imagem de referência.",
	"settings.default_keyframe_interpolation": "Interpolação de quadro-chave padrão",
	"settings.default_keyframe_interpolation.desc": "Seleciona o modo de interpolação de quadro-chave padrão.",
	"settings.color_picker_style": "Estilo de seleção de cores",
	"settings.color_picker_style.desc": "Seleciona o estilo do seletor de cores do modo pintura.",
	"settings.export_asset_paths": "Caminhos de ativos de exportação",
	"settings.export_asset_paths.desc": "Seleciona como os caminhos para recursos como texturas ou animações serão salvos nos arquivos .bbmodel.",
	"settings.export_asset_paths.relative": "Caminhos relativos",
	"settings.export_asset_paths.absolute": "Caminhos completos",
	"settings.export_asset_paths.both": "Caminhos relativos e completos (Apenas textura)",
	"settings.export_asset_paths.none": "Nenhuma exportação",
	"action.slider_spline_resolution": "Resolução da ranhura %0",
	"action.slider_spline_resolution.desc": "Altera a resolução da ranhura no eixo %0 (%1).",
	"action.slider_spline_resolution.u.desc_precision": "Segmentos de anel",
	"action.slider_spline_resolution.v.desc_precision": "Segmentos de tubo",
	"action.slider_spline_radius": "Raio da ranhura",
	"action.slider_spline_radius.desc": "Altera raio da ranhura",
	"action.slider_spline_handle_tilt": "Inclinação da curva",
	"action.slider_spline_handle_tilt.desc": "Altera a curva de inclinação",
	"action.slider_spline_handle_size": "Tamanho da curva",
	"action.slider_spline_handle_size.desc": "Alterar o tamanho da curva estriada",
	"action.blend_mode.lighten": "Clearear",
	"action.blend_mode.darken": "Escurecer",
	"action.weight_brush": "Pincel de peso",
	"action.weight_brush.desc": "Pinta os pesos de vértices em malhas para deformações de armação",
	"action.convert_minecraft_skin_variant": "Converter skin para fina/larga",
	"action.convert_minecraft_skin_variant.desc": "Alterna o modelo da skin entre o largo (steve) ou fino (alex). Ajusta automaticamente a textura para se adequar ao modelo (opcional)",
	"action.custom_skin_poses": "Pose personalizada para skin",
	"action.custom_skin_poses.desc": "Carrega uma predefinição personalizada de pose para a skin",
	"action.custom_skin_poses.update": "Atualizar pose",
	"action.custom_skin_poses.update.desc": "Substituir a pose salva com a atual do modelo",
	"action.add_custom_skin_pose": "Adicionar pose personalizada para skin",
	"action.add_custom_skin_pose.desc": "Salva a pose atual do modelo como uma predefinição de pose",
	"action.export_stl": "Exportar STL",
	"action.export_stl.desc": "Exporta um modelo STL para a impressão 3D.",
	"action.add_element": "Adicionar elemento",
	"action.add_element.desc": "Adiciona um novo elemento para a lista de tipos de elementos.",
	"action.add_spline": "Adicionar ranhura",
	"action.add_spline.desc": "Adiciona uma nova ranhura",
	"action.add_billboard": "Adicionar painel",
	"action.add_billboard.desc": "Adiciona um novo painel. Um elemento plano que está sempre voltado para a câmera.",
	"action.add_armature": "Adicionar armação",
	"action.add_armature.desc": "Adiciona uma armação que permite deformar uma malha por animação.",
	"action.add_armature_bone": "Adicionar armação de osso",
	"action.add_armature_bone.desc": "Adiciona um osso para a armação",
	"action.search_textures": "Buscar texturas",
	"action.search_textures.desc": "Busca texturas por nome",
	"action.search_animations": "Buscar animações",
	"action.search_animations.desc": "Busca animações por nome",
	"action.spline_selection_mode": "Modo de seleção de ranhura",
	"action.spline_selection_mode.object": "Objeto",
	"action.spline_selection_mode.handles": "Curvas",
	"action.spline_render_mode": "Geometria",
	"action.spline_render_mode.mesh": "Malha",
	"action.spline_render_mode.path": "Caminho",
	"action.spline_render_mode.desc": "Qual geometria essa ranhura deve renderizar?",
	"action.spline_uv_mode": "Estilo UV",
	"action.spline_uv_mode.length_accurate": "Comprimento preciso",
	"action.spline_uv_mode.uniform": "Uniforme",
	"action.spline_uv_mode.per_segment": "Por segmento",
	"action.spline_uv_mode.desc": "Como a malha tubular da ranhura deve posicionar suas coordenadas UV.",
	"action.spline_ring_segments": "Segmentos de anel",
	"action.spline_ring_segments.desc": "Quantas subdivisões essa ranhura tem por anel tubular?",
	"action.spline_tube_segments": "Segmentos de tubo",
	"action.spline_tube_segments.desc": "Quantas subdivisões essa ranhura tem ao longo do seu percurso?",
	"action.spline_tube_radius": "Raio do tubo",
	"action.spline_tube_radius.desc": "Define o raio do tubo da ranhura",
	"action.spline_display_space": "Espaço para exibição",
	"action.spline_display_space.desc": "Mostra os indicadores de espaçamento da ranhura em seu caminho.",
	"action.spline_handle_mode": "Modo ranhura estriada",
	"action.spline_handle_mode.desc": "Qual modo usar para transformar as curvas da ranhura.",
	"action.spline_handle_mode.aligned": "Alinhado",
	"action.spline_handle_mode.free": "Livre",
	"action.spline_handle_mode.mirrored": "Espelhado",
	"action.slider_weight_brush_size": "Tamanho do pincel de peso",
	"action.weight_brush_xray": "Modo raio-x do pincel de peso",
	"action.weight_brush_xray.desc": "Quando ativada, a ferramenta de pincel de peso afetará todos os vértices, e não apenas aqueles visíveis na superfície.",
	"action.apply_spline_rotation": "Aplicar rotação",
	"action.apply_spline_rotation.desc": "Redefine a rotação do elemento da curva e a aplique à geometria.",
	"action.extrude_spline_selection": "Extrusão de ranhura",
	"action.extrude_spline_selection.desc": "Expele a curva selecionada em todas as ranhuras.",
	"action.split_spline": "Ranhura dividida",
	"action.split_spline.desc": "Divide a ranhura em duas na curva selecionada.",
	"action.divide_spline_curve": "Dividir segmento de ranhura",
	"action.divide_spline_curve.desc": "Divide o segmento de ranhura em dois novos segmentos com uma nova curva na intersecção entre eles.",
	"action.set_vertex_weights": "Definir pesos dos vértices",
	"action.set_vertex_weights.desc": "Define os pesos dos vértices selecionados para um valor específico em um determinado osso da armação.",
	"action.calculate_vertex_weights": "Calcular pesos dos vértices",
	"action.calculate_vertex_weights.desc": "Atribue automaticamente pesos aos vértices com base na posição dos ossos.",
	"action.shelf_alignment": "Alinhamento de prateleira",
	"action.shelf_alignment.desc": "Selecione o alinhamento vertical dos itens na prateleira.",
	"action.shelf_alignment.top": "Alinhamento superior",
	"action.shelf_alignment.bottom": "Alinhamento inferior",
	"action.view_mode.vertex_weight": "Peso do vértice",
	"action.view_mode.weighted_bone_colors": "Cores dos ossos do vértice",
	"action.create_animation_group": "Criar grupo de animação",
	"action.create_animation_group.desc": "Cria um grupo de animação.",
	"action.move_graph_keyframes_up": "Mover o gráfico de quadros-chave para cima",
	"action.move_graph_keyframes_down": "Mover o gráfico de quadros-chave para baixo",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Editor de expressão",
	"menu.color_picker.picker_type.normal": "Mapa normal",
	"menu.texture.flipbook_animation": "Animação de folioscópio",
	"menu.panel.attach_to": "Anexar a",
	"menu.animation.playing": "Reproduzindo",
	"menu.animation_file.save_as": "Salvar como",
	"menu.animator.quaternion_interpolation": "Interpolação de quatérnios",
	"edit.extrude_spline_selection.extend": "Estender",
	"edit.divide_spline_curve.position": "Posição",
	"group.bedrock_binding": "Vinculado",
	"group.cem_attach": "Anexo CEM",
	"group.cem_model": "Modelo CEM",
	"group.cem_scale": "Escala CEM",
	"cube.rescale": "Redimensionamento da rotação",
	"cube.rescale.desc": "Redimensiona o cubo para compensar o ângulo de rotação.",
	"mesh.shading": "Sombreamento",
	"mesh.shading.flat": "Plano",
	"mesh.shading.smooth": "Suave",
	"spline_mesh.cyclic": "Cíclico",
	"spline_mesh.cyclic.desc": "Indica se a ranhura selecionada deve formar um loop (ciclo).",
	"billboard.offset": "Desvio",
	"billboard.facing_mode": "Modo de frente",
	"billboard.facing_mode.lookat": "Olhar para",
	"billboard.facing_mode.lookat_y": "Olhar para Y",
	"billboard.facing_mode.rotate": "Girar",
	"billboard.facing_mode.rotate_y": "Girar eixo Y",
	"armature_bone.connected": "Conectado",
	"reference_image.blueprint": "Bloquear planta",
	"codec.image.alpha_channel": "Canal alfa",
	"codec.image.animation_fps": "Animação QPS",
	"panel.palette": "Paleta",
	"panel.keyframe.change_effect_file": "Alterar arquivo de efeito",
	"panel.transform": "Transformar",
	"panel.element.spline_dimensions": "Dimensões da curva",
	"display.slot.on_shelf": "Prateleira",
	"display.reference.shelf": "Prateleira (todos os espaços)",
	"display.reference.shelf_left": "Prateleira (espaço à esquerda)",
	"display.reference.shelf_center": "Prateleira (espaço central)",
	"display.reference.shelf_right": "Prateleira (espaço à direita)",
	"message.newer_project_format_version.title": "Cliente desatualizado",
	"message.newer_project_format_version.message": "Esse arquivo foi salvo em uma versão mais recente do Blockbench. Atualize o aplicativo para a versão %0 ou mais recente para poder abri-lo corretamente",
	"message.load_images.add_layer": "Adicionar como camada",
	"message.load_images.category.add_to_project": "Adicionar ao projeto",
	"message.load_images.category.new_project": "Novo projeto",
	"message.load_palette.title": "Carregar paleta",
	"message.load_palette.message": "Deseja mesmo carregar essa paleta? Isso substituirá a sua atual.",
	"dialog.set_vertex_weights.weight": "Peso",
	"dialog.set_vertex_weights.overwrite": "Sobrescrever outros ossos",
	"action.element_render_order.short": "Renderizar ordem",
	"action.element_render_order.desc": "Ordem de renderização dos elementos. Isso pode ajudar a corrigir elementos que estão ocultos atrás de outros elementos com texturas transparentes. Deixe em 'automático' para elementos opacos.",
	"spline.shading.flat": "Plano",
	"spline.shading.smooth": "Suave",
	"spline.shading": "Sombreamento",
	"spline.shading.desc": "Como o tubo dessa ranhura deve ser sombreado.",
	"action.slider_weight_brush_limit": "Limite do pincel de peso",
	"action.slider_weight_brush_limit.desc": "Define um limite máximo para a quantidade de peso que o pincel pode atribuir a um vértice.",
	"action.weight_brush_blend_mode": "Modo de mesclagem do pincel de peso",
	"action.weight_brush_blend_mode.set": "Definir",
	"action.weight_brush_blend_mode.add": "Adicionar",
	"action.apply_texture_to_elements": "Aplicar textura para os elementos",
	"action.apply_texture_to_elements.desc": "Aplica a textura selecionada aos elementos selecionados.",
	"menu.panel.reset_size": "Redefinir tamanho",
	"action.import_layer": "Importar camada",
	"action.import_layer.desc": "Importar arquivo de imagem como camadas",
	"menu.collection.open_file": "Abrir arquivo",
	"layout.version": "Versão",
	"settings.status_bar_transform_sliders": "Transformar controles deslizantes na barra de status",
	"settings.status_bar_transform_sliders.desc": "Mostra a barra de ferramentas com os controles deslizantes de transformação da ferramenta selecionada na barra de status em vez de usar o painel de transformação.",
	"settings.default_bedrock_format": "Formato padrão do Bedrock",
	"settings.default_bedrock_format.desc": "Selecione o formato padrão para carregar os modelos do Minecraft Bedrock, quando nenhum formato específico puder ser detectado pelo contexto.",
	"settings.limit_brush_opacity_per_stroke": "Limitar a opacidade do pincel por traço",
	"settings.limit_brush_opacity_per_stroke.desc": "Limita a opacidade que um pincel pode aplicar ao valor do controle deslizante de opacidade durante cada pincelada. Com um pincel suave, esse comportamento pode gerar um leve ruído indesejado.",
	"action.merge_splines": "Mesclar ranhuras",
	"action.merge_splines.desc": "Mesclar várias ranhuras numa só",
	"settings.default_java_block_version": "Versão padrão do bloco/item Java",
	"settings.default_java_block_version.desc": "Versão de formato padrão ao criar novos modelos de bloco/item Java ou ao abrir arquivos sem versão de formato",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}